import { Location, formatDate } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import { faMinus, faPlus, faBookmark } from '@fortawesome/pro-regular-svg-icons';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { fabric } from 'fabric';
import { Subscription, forkJoin } from 'rxjs';
import { CartService } from 'src/app/services/cart.service';
import { CitylokApiService } from 'src/app/services/citylok-api.service';
import { EventsService } from 'src/app/services/events.service';
import { TicketsEventService } from 'src/app/services/tickets-event.service';
import { DialogGenericComponent } from '../dialog-generic/dialog-generic.component';
import { DialogUnlockSeatsComponent } from '../dialog-unlock-seats/dialog-unlock-seats.component';
import { GenerateMapService } from 'src/app/services/generate-map.service';
import { ReservasService } from 'src/app/services/reservas.service';
import { PassesService } from 'src/app/services/passes.service';
import { fixedPassOptions, fixedPassPrice, isFixedPricePass } from 'src/app/helpers/fixed-price-pass';

@Component({
  selector: 'app-seat-map',
  templateUrl: './seat-map.component.html',
  styleUrls: ['./seat-map.component.scss'],
})
export class SeatMapComponent implements OnChanges, AfterViewInit {

    today = new Date();
    dateDropdownOpen = false;
    hourDropdownOpen = false;

    compareHours(h1: any, h2: any): boolean {
        return h1 && h2 ? h1.time === h2.time : h1 === h2;
    }

    isHourDisabled(hour: any): boolean {
        const todayStr = formatDate(new Date(), 'yyyy-MM-dd', 'es');
        const todayHH = formatDate(new Date(), 'HH', 'es');
        return this.numDaySelect == null ||
               !hour.sessions.includes(this.dateString) ||
               (this.dateString === todayStr && hour.time.split(':')[0] <= todayHH);
    }

    selectDate(fecha: any) {
        this.dateSelect = fecha;
        this.changeDate(fecha);
        this.dateDropdownOpen = false;
    }

    selectHour(hour: any) {
        if (this.isHourDisabled(hour)) return;
        this.hourSelected = hour;
        this.changeHour(hour);
        this.hourDropdownOpen = false;
    }

    // Métodos para controlar la cantidad de tickets en eventos sin mapa
    incrementTicketQty() {
      if (this.ticketQty < this.enabled) {
        this.ticketQty++;
      }
    }

    decrementTicketQty() {
      if (this.ticketQty > 1) {
        this.ticketQty--;
      }
    }

    onTicketQtyInput() {
      this.ticketQty = +this.ticketQty;
      if (!this.ticketQty || this.ticketQty < 1) {
        this.ticketQty = 1;
      } else if (this.ticketQty > this.enabled) {
        this.ticketQty = this.enabled;
      }
    }
  // Cantidad de tickets para eventos sin mapa
  ticketQty: number = 1;
        // Zoom mínimo del plano (cuánto se puede alejar). Se necesita bien bajo para que los mapas
        // grandes quepan enteros en pantalla.
        private readonly MIN_ZOOM = 0.05;
        private autoScrollInterval: any = null;
        private readonly SCROLL_EDGE_SIZE = 60; // px desde el borde
        private readonly SCROLL_SPEED_MIN = 2; // px mínimo por ciclo (más lento)
        private readonly SCROLL_SPEED_MAX = 10; // px máximo por ciclo (más lento)
        private scrollDirection: 'up' | 'down' | null = null;
        private scrollDistance: number = 0;
      private isSpacePressed: boolean = false;

    // --- Listeners globales de teclado/ventana (guardados para poder removerlos) ---
    // Pan con barra espaciadora
    private onKeyDownSpace = (e: KeyboardEvent) => {
      if (e.code !== 'Space' || this.isSpacePressed) return;
      // No armar el pan si el usuario está escribiendo en un campo de texto
      if (this.isTypingTarget(e.target)) return;
      this.isSpacePressed = true;
      this.pausePanning = false;
      if (this.canvas) this.canvas.defaultCursor = 'move';
    };
    private onKeyUpSpace = (e: KeyboardEvent) => {
      if (e.code !== 'Space') return;
      this.releaseSpacePan();
    };
    private onKeyDownEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && this.massSelectionMode) {
        this.toggleMassSelection();
      }
    };
    // Si la ventana pierde el foco (alt-tab, diálogo del SO, cambio de app/pestaña)
    // mientras la barra está pulsada, el 'keyup' nunca llega y isSpacePressed se
    // quedaría bloqueado en true, forzando el pan sobre la selección masiva.
    private onWindowBlur = () => this.releaseSpacePan();
    private onVisibilityChange = () => {
      if (document.hidden) this.releaseSpacePan();
    };

    private releaseSpacePan() {
      if (!this.isSpacePressed) return;
      this.isSpacePressed = false;
      this.pausePanning = true;
      if (this.canvas) {
        this.canvas.defaultCursor = this.massSelectionMode ? 'crosshair' : 'default';
      }
    }

    private isTypingTarget(target: EventTarget | null): boolean {
      const el = target as HTMLElement;
      if (!el || !el.tagName) return false;
      const tag = el.tagName.toLowerCase();
      return tag === 'input' || tag === 'textarea' || tag === 'select' || el.isContentEditable;
    }

    activateLassoMode() {
      if (!this.massSelectionMode) this.toggleMassSelection();
      this.rectSelectionMode = false;
      this.isDrawingLasso = false;
      if (this.rectOverlay) {
        this.canvas.remove(this.rectOverlay);
        this.rectOverlay = null;
      }
      this.rectStart = null;
    }

    activateRectMode() {
      if (!this.massSelectionMode) this.toggleMassSelection();
      this.rectSelectionMode = true;
      this.isDrawingLasso = false;
      if (this.lassoOverlay) {
        this.canvas.remove(this.lassoOverlay);
        this.lassoOverlay = null;
      }
      this.lassoPoints = [];
    }
  mensaje: string;

  @Input() passMode: boolean = false;
  @Input() passMaxSeats: number = 1;
  @Input() passSelectedCount: number = 0;
  @Input() passPreselectedSeatIds: number[] = [];
  @Input() allowedSessionIds: number[] | null = null;
  // Abono de butaca única: el mapa es el del abono entero (no el de la sesión)
  // y no hay tarifa que elegir ni bloqueos que liberar; cada butaca pulsada se
  // emite tal cual por `passSelection` y la entrada la resuelve el back.
  @Input() singleSeatPass: any = null;
  // Venta evento a evento de un abono de precio fijo: en vez de las tarifas del
  // evento se ofrece una sola opción por nivel, a su precio en el abono.
  @Input() fixedPricePass: any = null;
  @Output() passSelection = new EventEmitter<any>();

  faPlus = faPlus;
  faMinus = faMinus;
  faChevronLeft = faChevronLeft;
  faBookmark = faBookmark;

  // --- Modo reserva ---
  /** Cuando reservationMode=true, los botones de carrito se reemplazan por "Reservar" */
  reservationMode: boolean = false;
  /** Cuando reservationMode=true, los botones de carrito se reemplazan por "Reservar" */
    // Removed duplicate declaration of ticketQty
  reservationId: number | null = null;
  loadingReserve: boolean = false;

  profile!: any;
  clicked: boolean = false;

  eventId!: any;

  event!: any;
  canvas: fabric.Canvas;

  objectMap!: any;
  selectTickets: any[] = [];
  pausePanning = true;
  selectedSeats: any[] = [];
  activedSeat!: any;

  totalPrice: any = 0;
  optionSection!: any;


  dateSelect!: any;
  timeSelect!: any;


  elementSeatSelect: any;
  fechas: any;

  // Default colors
  colorDefaultSeat: string = '#E8E8E8';
  colorDefaultStand: string = '#d8e1d7';
  colorDefaultFree: string = '#d8e1d7';
  colorDefaultStage: string = '#bae4ff';
  colorDefaultHidden: string = '#4d4d4d';
  colorDefaultReserved: string = '#7c4dff';
  colorDefaultSelect: string = '#FF4D80';
  colorDefaultDisplay: string = '#ffaec5';
  colorDefaultVisibility: string = '#aaaaaa';

  // Comprobar compras de evento, en la fecha y horas seleccionadas
  buysBuySelect: any[] = [];

  // --- Info de pedido/reserva al hacer hover sobre una butaca ocupada ---
  // Pedido o reserva al que pertenece cada butaca ocupada, indexado por id_seat.
  // Se carga por sesión (endpoint admin) e incluye butacas vendidas y de reservas.
  seatsOrders: { [id: number]: any } = {};
  // Mapa id_channel → nombre del canal de venta, para mostrarlo en el tooltip.
  channelsMap: { [id: number]: string } = {};
  seatOrderTooltip: { visible: boolean; x: number; y: number; data: any } = {
    visible: false, x: 0, y: 0, data: null
  };
  // Resaltado (borde rosa) de las butacas del mismo pedido/reserva bajo el puntero.
  private static readonly SEAT_HIGHLIGHT_COLOR = '#FF4D80';
  private highlightedGroupKey: any = null;
  private highlightedSeats: { circle: any; stroke: any; strokeWidth: any }[] = [];

  // HiddenSeat
  hiddenCode!: string;
  savedCode!: string;
  errorCode: boolean = false;
  openFormDiscount: boolean = false;
  discountObject!: any;

  enabled: number = 0;
  invite: boolean = false;
  checkInvite: boolean = false;

  optionsHours: any[] = [];
  hourSelected: any;

  dateSelected!: any;

  fechasEvent!: any;

  now = new Date();
  firstWeek: any[] = [];
  isEventMap: boolean = false;
  ticketOptionsNoMap: any[] = [];
  ticketOptionSelectedNoMap: any;
  loadedMap: boolean = false;

  loadingAddCart: boolean = false;
  numDaySelect!: number;
  dateDaySelect!: number;

  // Mass seat selection (lasso tool)
  massSelectionMode: boolean = false;
  selectionModeType: 'new' | 'add' | 'subtract' = 'new';
  isDrawingLasso: boolean = false;
  lassoPoints: { x: number; y: number }[] = [];
  lassoOverlay: fabric.Polyline | null = null;

  massSelectedSeats: any[] = [];
  massTicketOption: any = null;
  massOptionSection: any[] = [];
  loadingMassCart: boolean = false;

  buttonPanMode: boolean = false;

  // Debounce para getInfoCapacity() - evita llamadas excesivas
  private getInfoCapacityTimeout: any = null;

  // Track last pointer position for lasso tool
  lastLassoPointer: { x: number; y: number } | null = null;

    // Selección rectangular
    rectSelectionMode: boolean = false;
    rectStart: { x: number; y: number } | null = null;
    rectOverlay: fabric.Rect | null = null;

  currentRoute: string = '';
  previousRoute: string = '';

  private cartSubscription: Subscription;
  private confirmSubscription: Subscription;
  private seatRemovedSubscription: Subscription;
  private deleteCartSubscription: Subscription;
  private deleteItemsSubscription: Subscription;
  private mapSessionSubscription: Subscription;
  // Identifica la carga del mapa en curso: si llega otra antes de que termine, la vieja se descarta.
  private mapLoadId = 0;
  // El mapa se pinta al 50% en la esquina y se encaja un tick después: hasta entonces no se enseña,
  // para que no se vea el salto.
  mapFitted = false;

  // Sessions
  sessionSelected!: any;
  optionsTickets: any[] = [];
  enabledTickets: any[] = [];

  // Mapa de asientos
  seatSections: { [key: number]: any } = {};
  canvasObjects: { [key: string]: any } = {};
  objectIdCounter: number = 1;
  screenElement: string = '/assets/images/canvas/screen-users-light.svg';
  shoesElement: string = '/assets/images/canvas/shoe-prints-light.svg';
  sectionNumber: number = 1;
  levelSelected: any;
  sectionsEnabled: any[] = [];
  levelsEnabled: any[] = [];
  // Navegación por zonas (opt-in). Si está desactivado o no hay zonas → comportamiento actual.
  zoneNavigation: boolean = false;
  navZones: any[] = [];
  inOverview: boolean = false;
  navZoneObjects: any[] = [];
  dateString!: string;
  blockedSeats: any[] = [];
  reservedSeats: any[] = [];
  allSeatsBlocked: any[] = [];
  cartBookings: any[] = [];

  eventSoldOut: boolean = false;
  eventLimitActual: number = 0;

  constructor(
    private ticketsEventService: TicketsEventService,
    private location: Location,
    private cartService: CartService,
    private activatedRoute: ActivatedRoute,
    private eventsService: EventsService,
    private citylokService: CitylokApiService,
    public formatter: NgbDateParserFormatter,
    private router: Router,
    private dialog: MatDialog,
    private generateMapService: GenerateMapService,
    private reservasService: ReservasService,
    private passesService: PassesService
  ) { }

  goBack() {
    this.location.back();
  }

  manejarEvento(seat: any) {
    if (seat) {
      seat.selectable = true;
      seat.selected = false;
      let elementStroke = seat._objects.find((value) => value.type != 'text');
      let defaultColor = seat.level ? seat.level.color : this.colorDefaultSeat;
      let colorFill = seat.selected ? this.colorDefaultSelect : defaultColor;
      elementStroke.set('fill', colorFill);
      let elementsText = seat._objects.filter(
        (value) => value.type == 'text' || value.type == 'path'
      );
      let colorText = seat.selected ? 'white' : 'black';
      elementsText.forEach((elementText) => {
        elementText.set('fill', colorText);
      });
      this.canvas.renderAll();

    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['passPreselectedSeatIds'] && !changes['passPreselectedSeatIds'].firstChange) {
      if (this.loadedMap && this.canvas) {
        this.applyPassPreselectedColors();
      }
    }
  }

  applyPassPreselectedColors() {
    if (!this.canvas || !this.passPreselectedSeatIds?.length) return;
    const objects = this.canvas._objects;
    objects.forEach((element: any) => {
      if (element.groupSeat) {
        const seatsGroup = element._objects[1];
        seatsGroup._objects.forEach((seat: any) => {
          if (!seat.eventSeat || !seat.id) return;
          if (this.passPreselectedSeatIds.includes(seat.id)) {
            const circle = seat._objects.find((v: any) => v.type !== 'text');
            if (circle) circle.set('fill', this.colorDefaultSelect);
            const texts = seat._objects.filter((v: any) => v.type === 'text' || v.type === 'path');
            texts.forEach((t: any) => t.set('fill', 'white'));
          }
        });
      }
    });
    this.canvas.renderAll();
  }

  clearPassSelections(seatIds: number[]) {
    if (!this.canvas) return;
    const objects = this.canvas._objects;
    objects.forEach((element: any) => {
      if (element.groupSeat) {
        const seatsGroup = element._objects[1];
        seatsGroup._objects.forEach((seat: any) => {
          if (!seat.eventSeat || !seat.id) return;
          if (!seatIds.includes(seat.id)) return;
          seat.selected = false;
          seat.selectable = true;
          this.cartBookings = (this.cartBookings || []).filter((id: number) => id !== seat.id);
          const circle = seat._objects.find((v: any) => v.type !== 'text');
          const texts = seat._objects.filter((v: any) => v.type === 'text' || v.type === 'path');
          const defaultColor = seat.level?.color || this.colorDefaultSeat;
          if (circle) circle.set('fill', defaultColor);
          const rgb = hexToRgb(defaultColor);
          const textColor = rgb && (rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114) > 186 ? '#000' : '#fff';
          texts.forEach((t: any) => t.set('fill', textColor));
        });
      }
    });
    this.canvas.renderAll();
  }

  ngOnInit(): void {
    this.hourSelected = null;
    this.eventId = null;

    // Leer reservationId de los query params para activar modo reserva
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      const rid = queryParams['reservationId'];
      if (rid) {
        this.reservationId = Number(rid);
        this.reservationMode = true;
      } else {
        this.reservationId = null;
        this.reservationMode = false;
      }
    });

    //Nos suscribimos a los cambios de la URL para obtener el id del evento
    this.activatedRoute.params.subscribe((data) => {

      this.openFormDiscount = false;
      this.hiddenCode = '';
      this.discountObject = null;
      this.errorCode = false;
      this.savedCode = null;

      this.loadedMap = false;
      const newEventId = data['idEvent'];
      // Si cambia el evento, resetear el estado de selección masiva
      // (no se hace en getData porque getData también se llama tras compras/cambios de carrito
      // y queremos preservar el modo masivo si estaba activo)
      if (newEventId && this.eventId && newEventId != this.eventId) {
        this.massSelectionMode = false;
        this.massSelectedSeats = [];
        this.massOptionSection = [];
        this.massTicketOption = null;
      }
      this.eventId = newEventId;

      if (this.eventId) {
        const exitEvent = this.eventsService.getEventsSaved(this.eventId);

        this.currentRoute = this.router.url;
        if (!exitEvent) {
          this.eventsService.getEventById(this.eventId).subscribe((eventData) => {
            this.eventsService.addEventSaved(eventData);

            this.event = eventData;
            this.eventSoldOut = this.event.soldOut;
            this.enabled = this.event.capacity || this.event.space?.capacity;
            this.eventLimitActual = 0;

            this.getData(eventData);

          }, (error) => {
            console.log('Error al obtener el evento', error);

          });
        } else {
          this.event = exitEvent;
          this.getData(exitEvent);
        }
      }
    });
  }
  ngAfterViewInit() {
        // Permitir panning con la tecla espacio.
        // Los listeners se guardan en propiedades para poder eliminarlos en ngOnDestroy
        // (si no, se acumulan en cada recreación del componente) y para resetear
        // isSpacePressed si la ventana pierde el foco con la barra pulsada.
        window.addEventListener('keydown', this.onKeyDownSpace);
        window.addEventListener('keyup', this.onKeyUpSpace);
        window.addEventListener('blur', this.onWindowBlur);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
    this.cartSubscription = this.cartService.cartStateObs$.subscribe((data) => {
      if (data?.remove) {
        this.getData(this.event);
      }
      if (!this.isEventMap && this.event?.capacity && !this.event?.soldOut) {
        // Debounce getInfoCapacity() para evitar llamadas excesivas
        if (this.getInfoCapacityTimeout) {
          clearTimeout(this.getInfoCapacityTimeout);
        }
        this.getInfoCapacityTimeout = setTimeout(() => {
          this.getInfoCapacity();
          this.getInfoCapacityTimeout = null;
        }, 300); // Espera 300ms antes de ejecutar
      }
    });

    this.seatRemovedSubscription = this.reservasService.seatRemoved$.subscribe((seatIds: number[]) => {
      if (this.canvas && this.isEventMap) {
        this.clearPassSelections(seatIds);
      }
    });

    this.confirmSubscription = this.cartService.payCartObs$.subscribe((data) => {
      if (data?.pay) {
        if (this.isEventMap) {
          document.querySelectorAll('canvas').forEach(canvas => {
            if (canvas.id !== 'myCanvas') {
              canvas.remove();
            }
          });
          // Limpiar estado transitorio de la selecci\u00f3n masiva al recargar el mapa
          // (se preserva massSelectionMode para que el usuario siga en el mismo modo)
          this.massSelectedSeats = [];
          this.massOptionSection = [];
          this.massTicketOption = null;
          this.loadingMassCart = false;
          this.isDrawingLasso = false;
          this.lassoPoints = [];
          this.lassoOverlay = null;
          this.rectStart = null;
          this.rectOverlay = null;
          this.loadedMap = false;
          this.getMapSession();
        }
        this.cartService.setCartConfirmed(null);
      }
    });
    window.addEventListener('keydown', this.onKeyDownEscape);
  }

  getInfoCapacity() {
    if (this.sessionSelected) {
      this.eventsService.getInfoCapacityEvent(this.sessionSelected?.id).subscribe((eventData) => {
        this.enabled = eventData.capacity - eventData.booked;
        this.eventSoldOut = this.event.soldOut || (this.enabled <= 0);
      });
    }
  }

  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
    if (this.confirmSubscription) {
      this.confirmSubscription.unsubscribe();
    }
    if (this.seatRemovedSubscription) {
      this.seatRemovedSubscription.unsubscribe();
    }
    if (this.deleteCartSubscription) {
      this.deleteCartSubscription.unsubscribe();
    }
    if (this.deleteItemsSubscription) {
      this.deleteItemsSubscription.unsubscribe();
    }
    if (this.mapSessionSubscription) {
      this.mapSessionSubscription.unsubscribe();
    }
    this.mapLoadId++;
    if (this.getInfoCapacityTimeout) {
      clearTimeout(this.getInfoCapacityTimeout);
    }
    // Eliminar los listeners globales para evitar fugas y acumulación entre instancias
    window.removeEventListener('keydown', this.onKeyDownSpace);
    window.removeEventListener('keyup', this.onKeyUpSpace);
    window.removeEventListener('keydown', this.onKeyDownEscape);
    window.removeEventListener('blur', this.onWindowBlur);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.clearAutoScroll();
  }

  getData(eventData: any) {
    this.ticketQty = 1;
    if (eventData) {

      //Borramos si existe otro canvas que no sea el principal
      document.querySelectorAll('canvas').forEach(canvas => {
        if (canvas.id !== 'myCanvas') {

          canvas.remove();
        }
      });
      this.activedSeat = null;
      this.event = eventData.data ? eventData.data : eventData;
      this.optionsTickets = this.filterPassTickets(this.event.tickets.filter(ticket => ticket.active == true));


      const now = new Date();
      this.event.sessions = this.event.sessions.filter((session: any) => {
        if (!(new Date(session.start_date) >= now || (session.end_date && new Date(session.end_date) >= now))) return false;
        if (this.allowedSessionIds !== null && !this.allowedSessionIds.includes(session.id)) return false;
        return true;
      });

      //Option Dates
      const orderSessions = this.event.sessions.sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime());
      this.fechasEvent = orderSessions;

      // Obtener un array con las fechas únicas de las sesiones, las sesiones tienen el campo start_date que tiene tanto fecha como hora
      this.fechas = [...new Set(this.fechasEvent.map((session: any) => formatDate(new Date(session.start_date), 'yyyy-MM-dd', 'es', '+0000')))];
      this.dateSelect = this.fechas[0];

      //Options Hours
      this.optionsHours = [];
      // this.optionsHours = this.event.horarios.filter((hor: any) => hor.activo == true);
      this.optionsHours = this.optionsHours.sort((a: any, b: any) => {
        return new Date(a.horaInicio).getTime() - new Date(b.horaInicio).getTime();
      })
      this.optionsHours = [];
      this.dateString = formatDate(this.fechasEvent[0].start_date, 'dd-MM-yyyy', 'es', '+0000');
      this.fechasEvent.forEach(session => {
        const date = new Date(session.start_date);
        const dateString = formatDate(date, 'dd-MM-yyyy', 'es', '+0000');
        const timeKey = formatDate(date, 'HH:mm', 'es', '+0000');
        const optionExist = this.optionsHours.find(option => option.time == timeKey)
        if (!optionExist) {
          this.optionsHours.push({ time: timeKey, sessions: [dateString], dates: [session.start_date] });
        } else {
          optionExist.sessions.push(dateString);
          optionExist.dates.push(session.start_date);
        }
      });

      // this.dateSelect = this.fechas[0];
      // let dateFin = new Date(this.fechasEvent[0].end_date).toISOString();

      if (this.previousRoute === this.currentRoute && this.hourSelected) {
        this.hourSelected = this.hourSelected;
      } else {

        let firstHourDate = this.optionsHours.find(option => option.sessions.length > 0 && option.sessions.includes(this.dateString));
        this.hourSelected = firstHourDate;
        const optionSession = this.hourSelected.dates.find(session => formatDate(new Date(session), 'dd-MM-yyyy', 'es', '+0000') == this.dateString);
        this.sessionSelected = this.fechasEvent.find((sesion: any) => sesion.start_date == optionSession);
        if (this.dateSelect) {
          this.getTicketsEnabled();
        }
      }

      this.numDaySelect = new Date(this.fechasEvent[0].start_date).getDay();
      this.dateDaySelect = new Date(this.fechasEvent[0].start_date).getDate();
      //Comprobamos si el evento tiene mapa
      this.isEventMap = this.event.map_version;

      //Si no tiene mapa, obtenemos los tipos de tickets del evento
      if (!this.isEventMap) {
        this.ticketOptionsNoMap = this.enabledTickets?.length ? this.enabledTickets : this.optionsTickets;
        this.ticketOptionSelectedNoMap = this.ticketOptionsNoMap[0];
        this.loadedMap = true;
        this.eventSoldOut = this.event.soldOut;
        this.getInfoCapacity();
      } else {
        // Obtener la información del mapa del evento para la session seleccionada
        this.getMapSession();
      }
      this.previousRoute = this.currentRoute;
      // });
    }

    // if (this.savedCode) {
    //   this.applyCode();
    // }
  }

  getMapSession() {
    // Dos recargas solapadas (p. ej. limpiar el carrito dos veces seguidas) montaban dos
    // fabric.Canvas sobre el mismo <canvas>: el upper-canvas del primero quedaba encima sin
    // eventos y el mapa dejaba de responder. Solo cuenta la última carga pedida.
    const loadId = ++this.mapLoadId;
    this.mapFitted = false;
    this.mapSessionSubscription?.unsubscribe();
    const map$ = this.singleSeatPass
      ? this.passesService.getPassSeatMap(this.singleSeatPass.id)
      : this.eventsService.getMapEventBySession(this.eventId, this.sessionSelected.id);
    this.mapSessionSubscription = map$.subscribe({
      next: (response: any) => {
        let mapData = response.data;
        if (this.singleSeatPass) {
          // Para el abono solo hay butacas libres en todos los eventos y butacas
          // que no: vendidas, reservadas, bloqueadas y sin entrada general se
          // pintan igual, como ocupadas, y ninguna se puede desbloquear.
          mapData = {
            ...mapData,
            booked_seats: [
              ...(mapData.booked_seats || []),
              ...(mapData.reserved_seats || []),
              ...(mapData.blocked_seats || []),
              ...(mapData.unavailable_seats || []),
            ],
            reserved_seats: [],
            blocked_seats: [],
          };
        }
        this.objectMap = mapData;
        this.levelsEnabled = this.objectMap.levels;
        this.sectionsEnabled = this.objectMap.sections;
        // Flags de navegación por zonas (mapas antiguos no los traen → desactivado).
        this.zoneNavigation = !!this.objectMap.zoneNavigation;
        this.navZones = this.objectMap.navZones || [];
        this.blockedSeats = (this.objectMap.blocked_seats || []).map((b: any) => ({
          ...b,
          id_seats: typeof b.id_seats === 'string' ? JSON.parse(b.id_seats) : (b.id_seats || [])
        }));
        this.reservedSeats = this.objectMap.reserved_seats || [];
        this.buysBuySelect = this.objectMap.booked_seats;
        // Abono de precio fijo evento a evento: las zonas sin precio en este
        // evento no entran en el abono y se pintan como ocupadas, igual que en
        // el mapa de la butaca única. Si aun así se pulsa una, getEnabledTickets()
        // la rechaza. Va solo a buysBuySelect: no son ventas ni bloqueos.
        const outOfPassSeatIds = this.fixedPassOutOfPassSeatIds();
        if (outOfPassSeatIds.length > 0) {
          this.buysBuySelect = [...new Set([...this.buysBuySelect, ...outOfPassSeatIds])];
        }
        this.allSeatsBlocked = [...this.objectMap.booked_seats, ...this.blockedSeats];

        // Cargar la info de pedidos/reservas por butaca para el tooltip al hacer hover.
        this.loadSeatsOrders();

        if (this.objectMap) {
          this.enabled = (this.event.space.capacity - this.buysBuySelect.length);
          // Los niveles son obligatorios
          const levels = this.objectMap.levels;
          this.generateMapService.setLevelsMap(levels);

          // ✅ Convertir el array de objetos a objeto de clave-valor
          const configuration = this.objectMap.configuration;
          if (configuration) {
            const canvasObjects = this.convertArrayToKeyValueObject(configuration);
            this.generateMapService.setObjectsMap(configuration);
          }

          // ✅ Agrupar secciones y asientos desde objectMap
          if (this.objectMap.sections && this.objectMap.seats) {
            const seatSections = this.groupSectionsAndSeats(this.objectMap.sections, this.objectMap.seats);
            this.generateMapService.setSeatSections(seatSections);
          }
        }

        this.loadSectionsFromStorage();

        // Restos de un canvas anterior que no se hubieran retirado antes de recargar.
        document.querySelectorAll('canvas').forEach(canvas => {
          if (canvas.id !== 'myCanvas') {
            canvas.remove();
          }
        });
        this.canvas = new fabric.Canvas('myCanvas', {
          backgroundColor: '#fff',
          selection: false,
        });
        // Aumentar el área de trabajo del canvas para permitir scroll amplio
        let canvasWidth = 3000;
        let canvasHeight = 3000;
        this.canvas.setDimensions({ width: canvasWidth, height: canvasHeight });
        this.canvas.setZoom(0.6);

        document.fonts.load('16px Satoshi-Regular').finally(() => {
          if (loadId !== this.mapLoadId) return;
          this.recreateSectionsFromStorage();
          this.addCanvasEvents();
          this.canvas.setZoom(0.5);
          // Si el modo selecci\u00f3n masiva est\u00e1 activo, mantener el fondo rosa indicativo
          this.canvas.set('backgroundColor', this.massSelectionMode ? '#fff0f4' : '#f8f8f8');
          if (this.massSelectionMode) {
            this.canvas.defaultCursor = 'crosshair';
          }
          this.loadedMap = true;
          this.canvas.renderAll();
          // Inicializar navegación por zonas si el mapa la tiene activada (opt-in).
          this.initZoneNavigation();
          // El ajuste va tras el tick de Angular: hasta que `loadedMap` no pinta, el canvas está
          // oculto y no se puede medir. El segundo pase recoge los objetos asíncronos (escenario,
          // imágenes, SVG), que se añaden al canvas más tarde y pueden agrandar el plano.
          setTimeout(() => {
            if (loadId !== this.mapLoadId) return;
            this.fitMapToViewport();
            this.mapFitted = true;
          }, 0);
          setTimeout(() => { if (loadId === this.mapLoadId) this.fitMapToViewport(); }, 500);
        });
      },
      error: (error) => {
        if (loadId !== this.mapLoadId) return;
        console.log('Error al obtener el mapa del evento');
        this.objectMap = {};
      }
    });
  }

  // ─── Tooltip de pedido/reserva al hacer hover sobre una butaca ocupada ───

  // Carga la info de pedidos/reservas por butaca de la sesión seleccionada.
  loadSeatsOrders(): void {
    this.seatsOrders = {};
    this.loadChannelsMap();
    // En el mapa de un abono de butaca única una butaca puede estar ocupada en
    // cualquiera de sus eventos: el pedido de una sola sesión no la explica.
    if (!this.eventId || !this.sessionSelected?.id || this.singleSeatPass) {
      return;
    }
    this.eventsService.getEventSeatsOrders(this.eventId, this.sessionSelected.id).subscribe({
      next: (res: any) => {
        this.seatsOrders = res?.data || {};
      },
      error: () => {
        this.seatsOrders = {};
      }
    });
  }

  // Canales de venta (id → nombre). Se cachea: solo se pide la primera vez.
  loadChannelsMap(): void {
    if (Object.keys(this.channelsMap).length > 0) {
      return;
    }
    this.eventsService.getSalesChannels().subscribe({
      next: (res: any) => {
        const map: { [id: number]: string } = {};
        (res?.data || []).forEach((channel: any) => {
          if (channel?.id != null) {
            map[channel.id] = channel.name;
          }
        });
        this.channelsMap = map;
      },
      error: () => {
        this.channelsMap = {};
      }
    });
  }

  // ¿La butaca tiene un pedido/reserva asociado? (butaca ocupada con info que mostrar)
  isOccupiedSeat(seat: any): boolean {
    return !!(seat && seat.id != null && this.seatsOrders && this.seatsOrders[seat.id]);
  }

  // Título del tooltip: "Reserva" para reservas, "Pedido #..." para ventas.
  seatOrderTitle(data: any): string {
    if (!data) {
      return '';
    }
    if (data.type === 'reservation') {
      return 'Reserva';
    }
    return `Pedido #${data.invoice_number || data.order_id || ''}`;
  }

  // Etiqueta en español del estado del pedido/reserva para el tooltip.
  seatOrderStatusLabel(data: any): string {
    if (!data) {
      return '';
    }
    const labels: { [key: string]: string } = {
      completed: 'Completado',
      partial_refund: 'Reembolso parcial',
      refunded: 'Reembolsado',
      pending: 'Pendiente',
      processing: 'En proceso',
      reserved: 'Reservada'
    };
    return labels[data.status_short] || data.status || '';
  }

  // Color del estado, igual que el listado de pedidos del panel.
  seatOrderStatusColor(data: any): string {
    switch (data?.status_short) {
      case 'pending':
      case 'processing':
        return '#E9A41B';
      case 'paid':
      case 'completed':
        return '#2DAE29';
      case 'refund':
      case 'partial_refund':
        return '#13CDE2';
      case 'reserved':
        return '#7c4dff';
      default:
        return '#ff0000';
    }
  }

  // Nombre del canal del pedido (resuelto contra channelsMap). Las reservas no tienen canal.
  seatOrderChannelLabel(data: any): string {
    if (!data || data.id_channel == null) {
      return '';
    }
    return this.channelsMap[data.id_channel] || '';
  }

  // Clave de agrupación para el resaltado: distingue pedidos de reservas.
  private seatOrderGroupKey(data: any): any {
    if (!data) {
      return null;
    }
    return data.type === 'reservation' ? `r:${data.reservation_id}` : `o:${data.order_id}`;
  }

  // Muestra/actualiza/oculta el tooltip según la butaca ocupada bajo el puntero.
  private updateSeatOrderTooltip(e: any): void {
    if (!this.seatsOrders || Object.keys(this.seatsOrders).length === 0) {
      if (this.seatOrderTooltip.visible) { this.hideSeatOrderTooltip(); }
      return;
    }
    const elementSeat = this.resolveHoveredSeat(e);
    const data = elementSeat && elementSeat.id != null ? this.seatsOrders[elementSeat.id] : null;
    if (data && e && e.e) {
      this.seatOrderTooltip = {
        visible: true,
        x: (e.e as MouseEvent).offsetX,
        y: (e.e as MouseEvent).offsetY,
        data
      };
      // Resaltar todas las butacas del mismo pedido/reserva. Solo se recalcula al
      // cambiar el pedido/reserva bajo el puntero, no en cada movimiento.
      const groupKey = this.seatOrderGroupKey(data);
      if (groupKey !== this.highlightedGroupKey) {
        this.clearSeatHighlight();
        this.applySeatHighlight(groupKey);
        this.highlightedGroupKey = groupKey;
      }
      this.canvas.setCursor('pointer');
    } else if (this.seatOrderTooltip.visible || this.highlightedSeats.length > 0) {
      this.hideSeatOrderTooltip();
      this.clearSeatHighlight();
    }
  }

  private hideSeatOrderTooltip(): void {
    this.seatOrderTooltip = { visible: false, x: 0, y: 0, data: null };
  }

  // Pone el borde rosa a todas las butacas del pedido/reserva `groupKey`.
  private applySeatHighlight(groupKey: any): void {
    if (groupKey == null || !this.seatsOrders) {
      return;
    }
    const seatIds = new Set<string>();
    Object.keys(this.seatsOrders).forEach(seatId => {
      if (this.seatOrderGroupKey(this.seatsOrders[seatId]) === groupKey) {
        seatIds.add(String(seatId));
      }
    });
    if (seatIds.size === 0) {
      return;
    }
    this.forEachSeatObject(seat => {
      if (seat.id == null || !seatIds.has(String(seat.id))) {
        return;
      }
      const circle = seat._objects?.find((o: any) => o.type != 'text');
      if (!circle) {
        return;
      }
      this.highlightedSeats.push({ circle, stroke: circle.stroke, strokeWidth: circle.strokeWidth });
      circle.set({ stroke: SeatMapComponent.SEAT_HIGHLIGHT_COLOR, strokeWidth: 6 });
      seat.dirty = true;
    });
    if (this.highlightedSeats.length > 0) {
      this.canvas.renderAll();
    }
  }

  // Restaura el borde original de las butacas resaltadas.
  private clearSeatHighlight(): void {
    if (this.highlightedSeats.length === 0) {
      this.highlightedGroupKey = null;
      return;
    }
    this.highlightedSeats.forEach(({ circle, stroke, strokeWidth }) => {
      circle.set({ stroke, strokeWidth });
    });
    this.highlightedSeats = [];
    this.highlightedGroupKey = null;
    this.canvas?.renderAll();
  }

  // Recorre todas las butacas (objetos fabric con eventSeat) del canvas.
  private forEachSeatObject(cb: (seat: any) => void): void {
    if (!this.canvas) {
      return;
    }
    const walk = (objs: any[]) => {
      (objs || []).forEach(o => {
        if (o.eventSeat) {
          cb(o);
        }
        if (o._objects && o._objects.length) {
          walk(o._objects);
        }
      });
    };
    walk(this.canvas.getObjects());
  }

  // Resuelve la butaca (subtarget) bajo el puntero. Devuelve el objeto fabric o null.
  private resolveHoveredSeat(e: any): any {
    if (!e || !e.target) {
      return null;
    }
    if (e.target.eventSeat) {
      return e.target;
    }
    if (e.target.groupSeat && e.subTargets && e.subTargets.length > 0) {
      return e.subTargets[0];
    }
    return null;
  }

  /**
   * Inicializa la navegación por zonas (opt-in). Scaffold incompleto: si el mapa
   * no la trae activada (todos los mapas actuales) no hace nada. La implementación
   * real se añadirá en feature/seating-map-zone-zoom-navigation.
   */
  private initZoneNavigation(): void {
    if (!this.zoneNavigation) return;
    // TODO(zone-navigation): construir la navegación por zonas a partir de this.navZones.
  }

  getTicketsEnabled() {
    this.enabledTickets = [];
    this.selectTickets = [];
    if (this.dateSelect && (this.optionsHours.length > 0 && this.hourSelected || this.optionsHours.length <= 0)) {
      let stringDate = this.formatter.format(this.dateSelect);
      const date = new Date(stringDate);
      this.enabledTickets = this.optionsTickets;
    }
  }


  changeHour(hour: any) {
    document.querySelectorAll('canvas').forEach(canvas => {
      if (canvas.id !== 'myCanvas') {
        canvas.remove();
      }
    });
    this.loadedMap = false;
    this.activedSeat = null;
    this.hourSelected = hour;

    const optionSession = this.hourSelected.dates.find(session => formatDate(new Date(session), 'dd-MM-yyyy', 'es') == this.dateString);
    this.sessionSelected = this.fechasEvent.find((sesion: any) => sesion.start_date == optionSession);
    this.discountObject = null;
    this.hiddenCode = '';
    this.errorCode = false;
    this.savedCode = null;
    this.openFormDiscount = false;
    if (this.isEventMap) {
      this.getMapSession();
    }
    this.getInfoCapacity();
  }

  changeDate(newDate?: any) {
    // Si se pasa un parámetro, actualizar dateSelect
    document.querySelectorAll('canvas').forEach(canvas => {
      if (canvas.id !== 'myCanvas') {
        canvas.remove();
      }
    });
    this.loadedMap = false;
    this.activedSeat = null;
    const dateSelected = this.formatDateFront(newDate);

    this.dateString = formatDate(dateSelected, 'dd-MM-yyyy', 'es-ES', '+0000');

    this.numDaySelect = new Date(dateSelected).getDay();

    // Comprobar que la hora seleccionada tiene sesión en la fecha seleccionada
    let hasSession = this.hourSelected.dates.some(session => formatDate(new Date(session), 'dd-MM-yyyy', 'es', '+0000') == this.dateString);
    if (!hasSession) {
      let firstHourDate = this.optionsHours.find(option => option.sessions.length > 0 && option.sessions.includes(this.dateString));
      this.hourSelected = firstHourDate;
    }
    const optionSession = this.hourSelected.dates.find(session => formatDate(new Date(session), 'dd-MM-yyyy', 'es', '+0000') == this.dateString);
    this.sessionSelected = this.fechasEvent.find((sesion: any) => sesion.start_date == optionSession);
    if (this.dateString) {
      this.getTicketsEnabled();
      this.getInfoCapacity();
    }
    this.discountObject = null;
    this.hiddenCode = '';
    this.errorCode = false;
    this.savedCode = null;
    this.openFormDiscount = false;
    if (this.isEventMap) {
      this.getMapSession();
    }
  }

  loadMapConfig() {
    this.enabled = 0;
    this.canvas.setZoom(0.5);
    this.canvas.set('backgroundColor', '#f8f8f8');
    this.canvasColorLevels();
    this.canvas.renderAll();

    this.loadedMap = true;
    this.mapFitted = true;
  }

  loadSectionsFromStorage() {
    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        this.seatSections = storedSections;
      } catch (error) {
        this.seatSections = {};
      }
    }

    // ✅ Cargar otros objetos del canvas (escenarios, etc.)
    const storedObjects = this.generateMapService.getObjectsMap();
    if (storedObjects) {
      try {
        this.canvasObjects = storedObjects;

        // Actualizar el contador de objetos
        const objectIds = Object.keys(this.canvasObjects).map(id => {
          // Buscar números en el ID usando regex
          const match = id.match(/(\d+)$/); // Busca números al final del string
          return match ? parseInt(match[1]) : 0;
        }).filter(num => num > 0); // Filtrar números válidos

        if (objectIds.length > 0) {
          this.objectIdCounter = Math.max(...objectIds) + 1;
        }
      } catch (error) {
        this.canvasObjects = {};
      }
    }

    this.selectedSeats = this.cartService.getSelectedSeats();
    this.levelsEnabled = this.generateMapService.getLevelsMap();
    this.cartBookings = this.cartService.getCartBookings(this.sessionSelected?.id);
    if (this.passMode && this.passPreselectedSeatIds?.length > 0) {
      this.cartBookings = [...this.cartBookings, ...this.passPreselectedSeatIds];
    }
    // Este método corre en cada carga del mapa: sin cancelar la suscripción anterior se acumulaba
    // una por recarga, y al limpiar el carrito cada una volvía a pedir el mapa.
    this.deleteItemsSubscription?.unsubscribe();
    this.deleteItemsSubscription = this.cartService.deleteItemsObs$.subscribe((bookings) => {
      if (bookings) {
        let objects = this.canvas._objects;
        objects.forEach((element) => {
          if (element.groupSeat) {
            let arrayObject = element._objects[1];
            arrayObject._objects.forEach((seat) => {
              if (bookings.includes(seat.id)) {
                seat.actived = false;
                seat.selected = false;
                seat.hidden = false;
                if (seat.eventSeat) {
                  seat.hoverCursor = 'pointer';
                  seat.selectable = true;
                }
                let indexEl = this.selectedSeats.findIndex(
                  (value) => seat.id && value.id == seat.id);
                if (indexEl != -1) {
                  this.totalPrice -= +this.selectedSeats[indexEl].option.price;
                  this.selectedSeats.splice(indexEl, 1);
                }
                this.cartService.updateSelectedSeats(
                  this.selectedSeats
                );
                this.changeColorBasic(seat);
              }
            });
          }
        });
        this.canvas.renderAll();
      }
    });
    this.deleteCartSubscription?.unsubscribe();
    this.deleteCartSubscription = this.cartService.deleteCartObs$.subscribe((remove) => {
      if (remove) {
        document.querySelectorAll('canvas').forEach(canvas => {
          if (canvas.id !== 'myCanvas') {
            canvas.remove();
          }
        });
        this.cartService.setDeleteCartEvent(false);
        this.cartService.updateSelectedSeats([]);
        this.buysBuySelect = [];
        this.blockedSeats = [];
        this.cartBookings = [];
        this.loadedMap = false;
        this.discountObject = null;
        this.hiddenCode = '';
        this.errorCode = false;
        this.savedCode = null;
        this.openFormDiscount = false;
        if (this.isEventMap) {
          this.getMapSession();
        }
      }
    });
  }

  addCanvasEvents() {

    this.canvas.on('mouse:down', (e) => {
      if (this.loadingAddCart) return;
      // Si está pulsada la barra espaciadora o el botón de pan, activar panning y salir
      if (this.isSpacePressed || this.buttonPanMode) {
        this.pausePanning = false;
        this.canvas.defaultCursor = 'move';
        return;
      }

      // --- Selección rectangular tiene prioridad si está activa ---
      if (this.massSelectionMode && this.loadingMassCart) return;
      if (this.massSelectionMode && this.rectSelectionMode) {
        this.isDrawingLasso = false;
        const pointer = this.canvas.getPointer(e.e);
        this.rectStart = { x: pointer.x, y: pointer.y };
        if (this.rectOverlay) {
          this.canvas.remove(this.rectOverlay);
          this.rectOverlay = null;
        }
        this.rectOverlay = new fabric.Rect({
          left: pointer.x,
          top: pointer.y,
          width: 1,
          height: 1,
          fill: 'rgba(255, 77, 128, 0.12)',
          stroke: '#FF4D80',
          strokeWidth: 2 / this.canvas.getZoom(),
          selectable: false,
          evented: false,
          objectCaching: false,
        });
        this.canvas.add(this.rectOverlay);
        this.canvas.renderAll();
        return;
      }
      // --- Lasso ---
      if (this.massSelectionMode) {
        this.startLasso(e);
        return;
      }

      if (
        e.target &&
        (e.target.eventSeat ||
          (e.target.groupSeat &&
            e.subTargets.length > 0 &&
            e.subTargets[0].eventSeat))
      ) {
        let elementSeat = e.target.groupSeat ? e.subTargets[0] : e.target;
        if (elementSeat.selectable) {
          this.selectTicket(elementSeat);
        }
      }
      if ((!e.target || e.target.isInfoSection) && this.pausePanning == true) {
        this.pausePanning = false;
        this.canvas.discardActiveObject(this.canvas.getActiveObject());
        this.canvas.defaultCursor = 'move';
      }
    });

    this.canvas.on('mouse:over', (e) => {
      if (this.massSelectionMode) return;
      if (
        e.target &&
        (e.target.eventSeat || (e.target.groupSeat && e.subTargets?.length > 0))
      ) {
        let elementSeat = e.target.groupSeat ? e.subTargets[0] : e.target;
        // Las butacas ocupadas gestionan su borde con el resaltado del pedido/reserva.
        if (this.isOccupiedSeat(elementSeat)) return;
        let indexStroke = elementSeat._objects.find(
          (value) => value.type != 'text'
        );
        indexStroke.set('stroke', 'black');
        this.canvas.renderAll();
      }
    });

    this.canvas.on('mouse:out', (e) => {
      if (this.massSelectionMode) return;
      // Al salir del canvas (sin butaca destino) ocultar el tooltip y el resaltado.
      if (!e.target) {
        this.hideSeatOrderTooltip();
        this.clearSeatHighlight();
        return;
      }
      if (
        e.target.eventSeat || (e.target.groupSeat && e.subTargets?.length > 0)
      ) {
        let elementSeat = e.target.groupSeat ? e.subTargets[0] : e.target;
        if (this.isOccupiedSeat(elementSeat)) return;
        let indexStroke = elementSeat._objects.find(
          (value) => value.type != 'text'
        );
        indexStroke.set('stroke', '#4D4D4D');
        this.canvas.renderAll();
      }
    });

    this.canvas.on('mouse:wheel', (opt) => {
      var delta = opt.e.deltaY;
      var zoom = this.getZoom(false, delta);
      // El punto tiene que ir en coordenadas del propio canvas, no de la página: con pageX/pageY el
      // desplazamiento del lienzo (margen negativo + resto del layout) desviaba el zoom, y cuanto
      // más alejado, más se notaba.
      const canvasRect = this.canvas.getElement().getBoundingClientRect();
      var zoomPoint = new fabric.Point(opt.e.clientX - canvasRect.left, opt.e.clientY - canvasRect.top);
      this.canvas.zoomToPoint(zoomPoint, zoom);
      this.canvas.renderAll();
      opt.e.preventDefault();
      opt.e.stopPropagation();
    });

    var previousTouch;
    this.canvas.on('mouse:move', (e) => {
      // Hover sobre butacas ocupadas: muestra el pedido/reserva al que pertenecen.
      // Solo fuera de paneo y de selección masiva; en esos modos ocultamos el tooltip.
      if (!this.isSpacePressed && !this.buttonPanMode && !this.massSelectionMode) {
        this.updateSeatOrderTooltip(e);
      } else if (this.seatOrderTooltip.visible || this.highlightedSeats.length > 0) {
        this.hideSeatOrderTooltip();
        this.clearSeatHighlight();
      }
      // Si está pulsada la barra espaciadora o el botón de pan, permitir panning y salir
      if (this.isSpacePressed || this.buttonPanMode) {
        if (this.pausePanning == false && e && e.e) {
          if (!e.e.touches) {
            this.canvas = keepPositionInBounds(this.canvas, e);
          }
          if (e.e.touches) {
            const touch = e.e.touches[0];
            if (previousTouch) {
              e.e.movementX = touch.pageX - previousTouch.pageX;
              e.e.movementY = touch.pageY - previousTouch.pageY;
              this.canvas = keepPositionInBounds(this.canvas, e);
            }
            previousTouch = touch;
          }
        }
        return;
      }

      // ── Selección masiva: distinguir lasso y rectángulo ──
      if (this.massSelectionMode && this.loadingMassCart) return;
      if (this.massSelectionMode) {
        let isRect = this.rectSelectionMode && this.rectStart && this.rectOverlay;
        let isLasso = this.isDrawingLasso;
        if (isRect) {
          const pointer = this.canvas.getPointer(e.e);
          const left = Math.min(this.rectStart.x, pointer.x);
          const top = Math.min(this.rectStart.y, pointer.y);
          const width = Math.abs(pointer.x - this.rectStart.x);
          const height = Math.abs(pointer.y - this.rectStart.y);
          this.rectOverlay.set({ left, top, width, height });
          this.rectOverlay.setCoords();
          this.canvas.requestRenderAll();
        } else if (isLasso) {
          this.updateLasso(e);
        }
        // --- Auto-scroll vertical respecto al canvas (no la ventana) ---
        if ((isRect || isLasso) && e.e) {
          const canvasElement = this.canvas.getElement();
          const rawRect = canvasElement.getBoundingClientRect();
          // El canvas mide 3000px, pero visualmente está recortado por el contenedor.
          // Acotamos rect al viewport visible para que el borde inferior sea detectable.
          const visibleTop = Math.max(rawRect.top, 0);
          const visibleBottom = Math.min(rawRect.bottom, window.innerHeight);
          const rect = { top: visibleTop, bottom: visibleBottom };
          const mouseY = e.e.clientY;
          let direction: 'up' | 'down' | null = null;
          let distance = 0;
          // Borde superior del canvas
          if (mouseY <= rect.top + this.SCROLL_EDGE_SIZE) {
            direction = 'up';
            distance = Math.max(5, this.SCROLL_EDGE_SIZE - (mouseY - rect.top));
          }
          // Borde inferior del canvas
          else if (mouseY >= rect.bottom - this.SCROLL_EDGE_SIZE) {
            direction = 'down';
            distance = Math.max(5, this.SCROLL_EDGE_SIZE - (rect.bottom - mouseY));
          }
          if (direction && distance > 0) {
            this.startAutoScrollProportional(direction, distance);
          } else {
            this.clearAutoScroll();
          }
        } else {
          this.clearAutoScroll();
        }
        return;
      }

      this.clearAutoScroll();

      if (this.pausePanning == false && e && e.e) {
        if (!e.e.touches) {
          this.canvas = keepPositionInBounds(this.canvas, e);
        }
        if (e.e.touches) {
          const touch = e.e.touches[0];
          if (previousTouch) {
            e.e.movementX = touch.pageX - previousTouch.pageX;
            e.e.movementY = touch.pageY - previousTouch.pageY;
            this.canvas = keepPositionInBounds(this.canvas, e);
          }
          previousTouch = touch;
        }
      }
    });

    this.canvas.on('mouse:up', (e) => {
      previousTouch = null;
      // Si está pulsada la barra espaciadora o el botón de pan, terminar panning y salir
      if (this.isSpacePressed || this.buttonPanMode) {
        if (this.buttonPanMode) {
          // Soltar el click: stop drag pero cursor sigue siendo 'move' para el próximo arrastre
          this.pausePanning = true;
          this.canvas.defaultCursor = 'move';
        } else if (!this.canvas.getActiveObject() && this.pausePanning == false) {
          this.pausePanning = true;
          this.canvas.defaultCursor = 'default';
        }
        return;
      }

      // ── Selección masiva: distinguir lasso y rectángulo ──
      if (this.massSelectionMode && this.loadingMassCart) return;
      if (this.massSelectionMode) {
        if (this.rectSelectionMode && this.rectStart && this.rectOverlay) {
          const left = this.rectOverlay.left;
          const top = this.rectOverlay.top;
          const width = this.rectOverlay.width * this.rectOverlay.scaleX;
          const height = this.rectOverlay.height * this.rectOverlay.scaleY;
          const rectPoints = [
            { x: left, y: top },
            { x: left + width, y: top },
            { x: left + width, y: top + height },
            { x: left, y: top + height },
          ];
          this.applyLassoSelection(rectPoints);
          this.canvas.remove(this.rectOverlay);
          this.rectOverlay = null;
          this.rectStart = null;
          this.clearAutoScroll();
        } else if (this.isDrawingLasso) {
          this.finishLasso();
          this.clearAutoScroll();
        }
        return;
      }


      this.clearAutoScroll();


      if (!this.canvas.getActiveObject() && this.pausePanning == false && !this.isSpacePressed) {
        this.pausePanning = true;
        this.canvas.defaultCursor = 'default';
      }
    });
  }

  // --- Métodos de auto-scroll vertical ---
  private startAutoScrollProportional(direction: 'up' | 'down', distance: number) {
    // Si ya está en la misma dirección, solo actualiza la distancia
    if (this.autoScrollInterval && this.scrollDirection === direction) {
      this.scrollDistance = distance;
      return;
    }
    this.clearAutoScroll();
    this.scrollDirection = direction;
    this.scrollDistance = distance;
    this.autoScrollInterval = setInterval(() => {
      // Simular panning como Fabric.js
      let speed = this.SCROLL_SPEED_MIN + (this.scrollDistance / this.SCROLL_EDGE_SIZE) * (this.SCROLL_SPEED_MAX - this.SCROLL_SPEED_MIN);
      speed = Math.max(this.SCROLL_SPEED_MIN, Math.min(this.SCROLL_SPEED_MAX, speed));
      let movementY = (this.scrollDirection === 'up' ? speed : -speed);
      // Simular evento de panning
      const currentVp = this.canvas.viewportTransform;
      if (currentVp) {
        let didMove = false;
        // Usar keepPositionInBounds si está disponible
        if (typeof keepPositionInBounds === 'function') {
          // Simular un evento de movimiento
          const fakeEvent = {
            e: {
              movementX: 0,
              movementY: movementY
            }
          };
          this.canvas = keepPositionInBounds(this.canvas, fakeEvent);
          didMove = true;
        } else {
          // Fallback: mover el viewport manualmente pero limitado
          const zoom = this.canvas.getZoom();
          const canvasHeight = this.canvas.getHeight();
          const visibleHeight = this.canvas.getElement().parentElement?.clientHeight || window.innerHeight;
          const maxScrollY = 0;
          const minScrollY = Math.min(0, visibleHeight - canvasHeight * zoom);
          let newY = currentVp[5] + movementY;
          if (newY > maxScrollY) newY = maxScrollY;
          if (newY < minScrollY) newY = minScrollY;
          if (Math.abs(newY - currentVp[5]) > 0.5) {
            currentVp[5] = newY;
            this.canvas.setViewportTransform(currentVp);
            didMove = true;
          }
        }
        // Si hay overlay de lasso visible, actualizar su posición
        if (didMove && this.lassoOverlay) {
          this.lassoOverlay.setCoords();
          this.canvas.requestRenderAll();
        }
      }
    }, 16); // 60fps
  }

  private clearAutoScroll() {
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
      this.scrollDirection = null;
      this.scrollDistance = 0;
    }
    // Limpiar la última posición del lasso si no estamos dibujando
    if (!this.isDrawingLasso) {
      this.lastLassoPointer = null;
    }
  }

  selectTicket(elementSeat: any) {
    this.elementSeatSelect = elementSeat;
    if (elementSeat.selectable) {
      elementSeat.actived = elementSeat.actived ? false : true;
      elementSeat.selected = false;

      let sectionSeat = this.sectionsEnabled.find((sectionData: any) => {
        return sectionData.id_section == elementSeat.section?.id;
      });
      let levelSelect = this.levelsEnabled.find((level: any) => level.id == sectionSeat?.id_level);
      // const showAll = this.levelSelected?.id != levelSelect?.id && this.levelSelected;
      this.levelSelected = levelSelect || null;

      let defaultColor = elementSeat.isSection ? this.colorDefaultFree : elementSeat.color || sectionSeat?.color;

      // let defaultColor = elementSeat.level
      //   ? elementSeat.level.color
      //   : this.colorDefaultSeat;

      // Cambiar color circulo interior
      if (this.activedSeat) {
        this.activeChangeDefault();
      }
      let elementStroke = elementSeat._objects.find(
        (value) => value.type != 'text'
      );
      let colorFill = elementSeat.actived ? '#ff4d7f3f' : defaultColor;
      elementStroke.set('fill', colorFill);
      let colorText = 'black';
      if (!elementSeat.actived) {
        let rgb = hexToRgb(colorFill);
        colorText =
          rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114 > 186 ? '#000' : '#fff';
      }
      let elementsText = elementSeat._objects.filter(
        (value) => value.type == 'text' || value.type == 'path'
      );
      elementsText.forEach((elementText) => {
        elementText.set('fill', colorText);
      });

      let indexEl = this.selectedSeats.findIndex(
        (value) => elementSeat.id && value.id == elementSeat.id);

      if (indexEl != -1) {
        this.totalPrice -= +this.selectedSeats[indexEl].option.price;
        this.selectedSeats.splice(indexEl, 1);
        this.cartService.updateSelectedSeats(
          this.selectedSeats
        );
      }
      this.activedSeat = elementSeat.actived ? elementSeat : null;
      this.getEnabledTickets();
      this.canvas.renderAll();
    }
  }

  getEnabledTickets() {
    // Comprobar los tickets que tiene disponibles el asiento seleccionado
    this.optionSection = null;
    this.checkInvite = false;
    if (this.activedSeat && this.singleSeatPass) {
      this.selectSingleSeatPassSeat();
      return;
    }
    if (this.activedSeat && this.activedSeat.section) {
      // Cambiar API
      this.ticketsEventService.getTicketsBySessionSeat(this.sessionSelected.id, this.activedSeat.id)
        .subscribe({
          next: (res) => {
            if (res.data) {
              let tickets = res.data.sort((a, b) => b.price - a.price);
              tickets.forEach(element => {
                let price = element.price;
                let ticketSpecial = element.ticket_seats?.find((seat: any) => seat.seat_id == this.activedSeat.id);
                if (ticketSpecial) {
                  price = ticketSpecial.price;
                } else {
                  let levelTicket = element.ticket_levels?.find((level: any) => level.level_id == this.levelSelected?.id);
                  price = levelTicket ? levelTicket.price : element.price;
                }
                element.price = price;
              });
              this.optionSection = this.filterPassTickets(tickets, this.levelSelected?.id ?? null);
              if (this.isFixedPricePassMode() && this.optionSection.length === 0) {
                this.rejectSeatOutOfFixedPricePass();
              }
            }
          },
        });
    }
  }

  private isFixedPricePassMode(): boolean {
    return this.passMode && isFixedPricePass(this.fixedPricePass);
  }

  /**
   * Butacas (seats.id) de las zonas sin precio en esta sesión para un abono de
   * precio fijo vendido evento a evento. Se agrupan por su sección lógica igual
   * que en groupSectionsAndSeats(); como ese id puede repetirse entre niveles,
   * solo se deja fuera la butaca si ninguna sección con ese id tiene precio.
   * Gemelo de SeatsPanelComponent::fixedPassOutOfPassSeatIds de la web.
   */
  private fixedPassOutOfPassSeatIds(): number[] {
    if (!this.isFixedPricePassMode() || this.singleSeatPass || !this.sessionSelected?.id) {
      return [];
    }

    const sections: any[] = this.objectMap?.sections || [];
    const pricedSections = new Set(
      sections
        .filter((s: any) => fixedPassPrice(this.fixedPricePass, this.sessionSelected.id, s.id_level) != null)
        .map((s: any) => `${s.id_section}`)
    );

    return (this.objectMap?.seats || [])
      .filter((seat: any) => seat?.id != null && !pricedSections.has(`${seat.section}`))
      .map((seat: any) => +seat.id);
  }

  /** Precio fijo: el nivel de la butaca no tiene precio en el abono para este evento */
  private rejectSeatOutOfFixedPricePass() {
    const zoneName = this.levelSelected?.name ? `«${this.levelSelected.name}»` : 'Esta zona';
    this.optionSection = null;
    this.closeActived();
    this.dialog.open(DialogGenericComponent, {
      data: {
        title: 'Zona fuera del abono',
        subtitle: `${zoneName} no entra en el abono en esta función. Elige una butaca de otra zona.`,
        icon: 'info',
        buttons: [{ label: 'Cerrar', action: () => this.dialog.closeAll() }],
      },
    });
  }

  /**
   * Abono de butaca única: la butaca pulsada queda elegida sin pasar por el
   * panel de tarifas. El tope es el número de abonos de la venta.
   */
  private selectSingleSeatPassSeat() {
    const seat = this.activedSeat;
    if (this.passSelectedCount >= this.passMaxSeats) {
      this.dialog.open(DialogGenericComponent, {
        data: {
          title: 'Butacas ya seleccionadas',
          subtitle: 'Ya has elegido todas las butacas de esta venta. Quita una del resumen para poder elegir otra.',
          icon: 'info',
          buttons: [{ label: 'Cerrar', action: () => this.dialog.closeAll() }],
        },
      });
      this.closeActived();
      return;
    }

    seat.selected = true;
    this.elementSeatSelect.selectable = false;
    this.passSelection.emit({
      id_seat: seat.id,
      _display: {
        levelName: this.levelSelected?.name || null,
        seatSection: seat.section?.name || null,
        seatRow: seat.row || null,
        seatSeat: seat.seat || null,
      }
    });
    this.changeSeatsAddToCart();
  }

  /**
   * En venta de abono solo se ofrecen las entradas que admiten descuento: las demás no cuentan para el abono.
   * En uno de precio fijo, una sola opción por nivel con su precio en el abono (`levelId` = nivel de las
   * entradas, si no lo traen en `_levelId`); un nivel sin precio no tiene opción.
   */
  private filterPassTickets(tickets: any[], levelId?: number | null): any[] {
    if (!this.passMode) return tickets;
    if (this.isFixedPricePassMode()) {
      return fixedPassOptions(this.fixedPricePass, this.sessionSelected?.id, tickets || [], levelId);
    }
    return (tickets || []).filter((t: any) => t.allow_discounts !== false);
  }

  getMassEnabledTickets() {
    this.massOptionSection = [];
    const firstSeat = this.massSelectedSeats[0];
    if (!firstSeat || !this.sessionSelected) return;

    // Collect all distinct levels + one representative seat per level
    const levelSeatMap = new Map<number, { level: any; seat: any }>();
    this.massSelectedSeats.forEach(seat => {
      const sec = this.sectionsEnabled.find((s: any) => s.id_section == seat.section?.id);
      if (sec) {
        const lv = this.levelsEnabled.find((l: any) => l.id == sec.id_level);
        if (lv && !levelSeatMap.has(lv.id)) {
          levelSeatMap.set(lv.id, { level: lv, seat });
        }
      }
    });

    const entries = Array.from(levelSeatMap.values());

    if (entries.length === 0) {
      // Fallback: no section/level info, use original single-seat call
      this.ticketsEventService.getTicketsBySessionSeat(this.sessionSelected.id, firstSeat.id)
        .subscribe({
          next: (res) => {
            if (res.data) {
              this.massOptionSection = this.filterPassTickets(res.data.sort((a: any, b: any) => b.price - a.price));
            }
          }
        });
      return;
    }

    if (entries.length === 1) {
      // Single level: original behaviour
      const { level, seat } = entries[0];
      this.ticketsEventService.getTicketsBySessionSeat(this.sessionSelected.id, seat.id)
        .subscribe({
          next: (res) => {
            if (res.data) {
              let tickets = res.data.sort((a: any, b: any) => b.price - a.price);
              tickets.forEach((element: any) => {
                let price = element.price;
                const ticketSpecial = element.ticket_seats?.find((s: any) => s.seat_id == seat.id);
                if (ticketSpecial) {
                  price = ticketSpecial.price;
                } else {
                  const levelTicket = element.ticket_levels?.find((l: any) => l.level_id == level.id);
                  price = levelTicket ? levelTicket.price : element.price;
                }
                element.price = price;
              });
              this.massOptionSection = this.filterPassTickets(tickets, level.id);
            }
          }
        });
      return;
    }

    // Multiple levels: call the API once per level in parallel
    const calls = entries.map(({ seat }) =>
      this.ticketsEventService.getTicketsBySessionSeat(this.sessionSelected.id, seat.id)
    );

    forkJoin(calls).subscribe({
      next: (results: any[]) => {
        const multiOptions: any[] = [];
        results.forEach((res: any, idx: number) => {
          if (!res.data) return;
          const { level, seat } = entries[idx];
          res.data.forEach((element: any) => {
            let price = element.price;
            const ticketSpecial = element.ticket_seats?.find((s: any) => s.seat_id == seat.id);
            if (ticketSpecial) {
              price = ticketSpecial.price;
            } else {
              const levelTicket = element.ticket_levels?.find((l: any) => l.level_id == level.id);
              price = levelTicket ? levelTicket.price : element.price;
            }
            multiOptions.push({
              ...element,
              price,
              _levelId: level.id,
              _levelName: level.name,
            });
          });
        });
        multiOptions.sort((a: any, b: any) => b.price - a.price);
        this.massOptionSection = this.filterPassTickets(multiOptions);
      }
    });
  }

  activeChangeDefault() {
    this.activedSeat.actived = false;
    this.changeColorBasic(this.activedSeat);
  }

  changeColorBasic(seat: any, hiddenSeat: boolean = false, showHidden: boolean = true) {
    let sectionSeat = Object.values(this.seatSections).find((sectionData: any) => {
      return sectionData.section.id == seat.section.id;
    });
    let color = sectionSeat ? seat.color || sectionSeat.section.color : this.colorDefaultSeat;

    let colorBasic = seat.section
      ? color
      : this.colorDefaultSeat;

    if (hiddenSeat) {
      if (!showHidden) {
        const blockedEntry = this.blockedSeats?.find((b: any) => b.id_seats?.includes(seat.id));
        colorBasic = blockedEntry?.color || this.colorDefaultHidden;
      } else {
        colorBasic = seat.section
          ? sectionSeat.section.color || this.colorDefaultSeat
          : this.colorDefaultSeat;
      }
    }

    let defaultColorActive = colorBasic;

    let elementActive = seat._objects.find(
      (value) => value.type != 'text'
    );

    if (!seat.selected) {
      elementActive.set('fill', defaultColorActive);
      let rgb = hexToRgb(defaultColorActive);
      defaultColorActive =
        rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114 > 186 ? '#000' : '#fff';
      let elementsText = seat._objects.filter(
        (value) => value.type == 'text' || value.type == 'path'
      );
      elementsText.forEach((elementText) => {
        elementText.set('fill', defaultColorActive);
      });
    }
    if (hiddenSeat) {
      if (showHidden) {
        const blockedEntry = this.blockedSeats?.find((b: any) => b.id_seats?.includes(seat.id));
        const strokeColor = blockedEntry?.color || this.colorDefaultHidden;
        elementActive.set('stroke', strokeColor);
        elementActive.set('strokeWidth', 10);
      } else {
        elementActive.set('stroke', '#4D4D4D');
        elementActive.set('strokeWidth', 2);
      }
    }
  }

  changeSelectTicketNoMap(ticket: any) {
    this.ticketOptionSelectedNoMap = ticket;
    this.ticketQty = 1;
  }

  addTicket(ticket: any) {
    if (this.loadingAddCart || this.loadingReserve) return;
    const actived = this.activedSeat;
    this.activedSeat.selected = true;

    let object = {
      event: this.event.id,
      section: actived.section,
      row: actived.row,
      seat: actived.seat,
      option: ticket,
      idbond: null,
      invite: null,
    };

    if (ticket.ibond) {
      object.idbond = ticket.idbond;
    }
    if (ticket?.invite) {
      object.invite = ticket.invite;
    }

    this.elementSeatSelect.selectable = false;

    if (this.reservationMode) {
      this.reserveTicket(ticket);
    } else {
      this.loadingAddCart = true;
      this.addToCart(ticket, actived);
    }
  }

  closeActived() {
    if (this.activedSeat) {
      this.activeChangeDefault();
      this.activedSeat = null;
      this.canvas.renderAll();
    }
  }

  changeSeatsAddToCart() {
    if (this.activedSeat) {
      this.activedSeat.actived = false;
      let elementStroke = this.activedSeat._objects.find(
        (value) => value.type != 'text'
      );
      let defaultColor = this.activedSeat.level
        ? this.activedSeat.level.color
        : this.colorDefaultSeat;
      let colorFill = this.activedSeat.selected
        ? this.colorDefaultSelect
        : defaultColor;
      elementStroke.set('fill', colorFill);
      let elementsText = this.activedSeat._objects.filter(
        (value) => value.type == 'text' || value.type == 'path'
      );
      let colorText = this.activedSeat.selected ? 'white' : 'black';
      elementsText.forEach((elementText) => {
        elementText.set('fill', colorText);
      });
      this.canvas.renderAll();
      this.activedSeat = null;

    }
  }

  addToCart(option: any, seat?: any) {
    // Si seat es un número, es evento sin mapa
    if (typeof seat === 'number') {
      let linepayload: any = {
        id_event: this.event.id,
        id_session: this.sessionSelected.id,
        quantity: seat,
        id_ticket: option.id,
      };
      if (this.passMode) {
        if (this.passSelectedCount >= this.passMaxSeats) {
          this.dialog.open(DialogGenericComponent, {
            data: {
              title: 'Entrada ya seleccionada',
              subtitle: 'Ya tienes una entrada seleccionada para este evento. Elimínala primero del abono para poder seleccionar una nueva.',
              icon: 'info',
              buttons: [{ label: 'Cerrar', action: () => this.dialog.closeAll() }],
            },
          });
          return;
        }
        this.passSelection.emit({
          ...linepayload,
          _display: {
            eventTitle: this.event?.title,
            eventImage: this.event?.image_url,
            ticketName: option?.name || option?.ticket_name,
            ticketPrice: option?.price != null ? +option.price : null,
            sessionDate: this.sessionSelected?.start_date,
            seatLabel: null,
            seatSection: null,
            seatRow: null,
            seatSeat: null
          }
        });
        this.changeSeatsAddToCart();
        return;
      }
      this.loadingAddCart = true;
      this.cartService.addToCart(linepayload).subscribe({
        next: (data) => {
          this.changeSeatsAddToCart();
          let subscribeCart = this.cartService.getCart().subscribe();
          this.loadingAddCart = false;
          this.ticketQty = 1;
        }, error: (error) => {
          this.loadingAddCart = false;
          this.dialog.open(DialogGenericComponent, {
            data: {
              title: 'Error al añadir al carrito',
              subtitle: 'No se ha podido añadir el ticket al carrito. Por favor, inténtalo de nuevo más tarde.',
              icon: 'error',
              buttons: [
                {
                  label: 'Cerrar',
                  action: () => this.dialog.closeAll(),
                },
              ],
            },
          });
        }
      });
    } else {
      // Evento con mapa (mantener lógica original)
      let linepayload: any = {
        id_event: this.event.id,
        id_session: this.sessionSelected.id,
        quantity: 1,
        id_ticket: option.id,
      };
      if (seat) {
        linepayload['id_seat'] = seat.id;
      }
      if (this.passMode) {
        if (this.passSelectedCount >= this.passMaxSeats) {
          this.loadingAddCart = false;
          this.dialog.open(DialogGenericComponent, {
            data: {
              title: 'Entrada ya seleccionada',
              subtitle: 'Ya tienes una entrada seleccionada para este evento. Elimínala primero del abono para poder seleccionar una nueva.',
              icon: 'info',
              buttons: [{ label: 'Cerrar', action: () => this.dialog.closeAll() }],
            },
          });
          return;
        }
        this.passSelection.emit({
          ...linepayload,
          _display: {
            eventTitle: this.event?.title,
            eventImage: this.event?.image_url,
            ticketName: option?.name || option?.ticket_name,
            ticketPrice: option?.price != null ? +option.price : null,
            sessionDate: this.sessionSelected?.start_date,
            seatLabel: seat ? `${seat.section?.name || ''} ${seat.row ? 'Fila ' + seat.row : ''} ${seat.seat ? 'Asiento ' + seat.seat : ''}`.trim() : null,
            seatSection: seat?.section?.name || null,
            seatRow: seat?.row || null,
            seatSeat: seat?.seat || null
          }
        });
        this.changeSeatsAddToCart();
        this.loadingAddCart = false;
        return;
      }
      this.cartService.addToCart(linepayload).subscribe({
        next: (data) => {
          this.changeSeatsAddToCart();
          let subscribeCart = this.cartService.getCart().subscribe();
          this.loadingAddCart = false;
        }, error: (error) => {
          this.loadingAddCart = false;
          this.dialog.open(DialogGenericComponent, {
            data: {
              title: 'Error al añadir al carrito',
              subtitle: 'No se ha podido añadir el ticket al carrito. Por favor, inténtalo de nuevo más tarde.',
              icon: 'error',
              buttons: [
                {
                  label: 'Cerrar',
                  action: () => this.dialog.closeAll(),
                },
              ],
            },
          });
        }
      });
    }
  }

  /**
   * Añade el ticket/asiento a la reserva activa.
   * Reutiliza el mismo payload que addToCart pero llama al endpoint de reservas.
   */
  addToReservation(option: any, seat?: any) {
    if (this.loadingReserve || !this.reservationId) return;
    this.loadingReserve = true;

    const linepayload: any = {
      id_event: this.event.id,
      id_session: this.sessionSelected.id,
      quantity: seat ? 1 : this.ticketQty,
      id_ticket: option.id,
    };
    if (seat) {
      linepayload['id_seat'] = seat.id;
    }

    // Pass mode: emit selection instead of adding to cart
    if (this.passMode) {
      this.passSelection.emit({
        ...linepayload,
        _display: {
          eventTitle: this.event?.title,
          eventImage: this.event?.image_url,
          ticketName: option?.name || option?.ticket_name,
          ticketPrice: option?.price != null ? +option.price : null,
          sessionDate: this.sessionSelected?.start_date,
          seatLabel: seat ? `${seat.section?.name || ''} ${seat.row ? 'Fila ' + seat.row : ''} ${seat.seat ? 'Asiento ' + seat.seat : ''}`.trim() : null,
          seatSection: seat?.section?.name || null,
          seatRow: seat?.row || null,
          seatSeat: seat?.seat || null
        }
      });
      this.changeSeatsAddToCart();
      this.loadingReserve = false;
      return;
    }

    this.reservasService.addLine(this.reservationId, linepayload).subscribe({
      next: () => {
        this.changeSeatsAddToCart();
        this.loadingReserve = false;
        this.reservasService.triggerLinesRefresh();
      },
      error: () => {
        this.loadingReserve = false;
        this.dialog.open(DialogGenericComponent, {
          data: {
            title: 'Error al reservar',
            subtitle: 'No se ha podido añadir la entrada a la reserva. Inténtalo de nuevo.',
            icon: 'error',
            buttons: [{ label: 'Cerrar', action: () => this.dialog.closeAll() }],
          },
        });
      },
    });
  }

  /** En modo reserva: reservar el ticket del asiento activo */
  reserveTicket(option: any) {
    if (this.loadingReserve) return;
    const actived = this.activedSeat;
    this.activedSeat.selected = true;
    this.elementSeatSelect.selectable = false;
    this.addToReservation(option, actived);
  }

  openUnlockDialog() {
    const dialogRef = this.dialog.open(DialogUnlockSeatsComponent, {
      data: { sessionId: this.sessionSelected.id },
      panelClass: 'unlock-seats-dialog',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.blocked_seats?.length > 0) {
        this.discountObject = result;
        this.savedCode = 'unlocked';
        this.desactiveHiddenSeat(true);
      }
    });
  }

  desactiveHiddenSeat(active: boolean) {
    let objects = this.canvas._objects;
    objects.forEach((element) => {
      element.hoverCursor = 'pointer';
      if (element.groupSeat) {
        let arrayObject = element._objects[1];
        arrayObject._objects.forEach((seat) => {
          seat.visible = seat.isVisible;
          seat.eventSeat = seat.eventSeat && seat.isVisible;
          let hiddenSeat = this.discountObject.blocked_seats.find((value) => value == seat.id);
          if (hiddenSeat) {
            seat.hidden = !active;
            seat.border = active;
            if (this.invite) {
              seat.invite = true;
            }
          }

          let exist = this.buysBuySelect.includes(seat.id);
          if (exist) {
            seat.hidden = true;
            seat.occupied = true;
          }

          let existReserved = this.reservedSeats.includes(seat.id);
          if (existReserved) {
            seat.hidden = true;
            seat.reserved = true;
          }

          if (seat.eventSeat) {
            seat.hoverCursor = 'pointer';
            seat.selectable = true;
          }
          if (seat.hidden) {
            seat.hoverCursor = 'default';
            seat.selectable = false;
          }

          if (existReserved) {
            let elementActive = seat._objects.find((value) => value.type != 'text');
            if (elementActive) {
              elementActive.set('fill', this.colorDefaultReserved);
              let elementsText = seat._objects.filter((value) => value.type == 'text' || value.type == 'path');
              elementsText.forEach((elementText) => elementText.set('fill', '#fff'));
            }
          } else if (hiddenSeat && !exist) {
            seat.hiddenActive = !active;
            this.changeColorBasic(seat, true, active);
          }
        });
      }
      if (!element.eventSeat || element.hidden || element.isInfoSection) {
        element.selectable = false;
        element.hoverCursor = 'default';
      }
    });
    this.canvas.renderAll();
    // this.canvasColorLevels();
  }

  deleteCode() {
    this.savedCode = null;
    this.errorCode = false;
    this.desactiveHiddenSeat(false);
    this.discountObject = null;
    this.invite = false;
    this.activedSeat = null;
  }

  canvasColorLevels(colorSelect: boolean = false) {
    // Comprobar los ocultos y priorizar el color de ocupado
    let objects = this.canvas._objects;
    objects.forEach((element) => {

      let colorHiddenDefault = this.blockedSeats.find(blocked => blocked.id_seats.includes(element.id));
      let colorHidden = element.occupied ? this.colorDefaultHidden : colorHiddenDefault?.color;
      let colorLevel = element.level ? element.level.color : this.colorDefaultSeat;

      let defaultColor = element.hidden
        ? colorHidden || this.colorDefaultHidden
        : colorLevel;
      if (element.isSection) {
        changeSeatColor(
          element,
          colorSelect ? this.colorDefaultSelect : defaultColor
        );
      }
      if (element.groupSeat) {
        let arrayObject = element._objects[1];
        arrayObject._objects.forEach((seat) => {
          let colorHidden = seat.occupied ? this.colorDefaultHidden : colorHiddenDefault;
          let colorLevel = seat.level ? seat.level.color : this.colorDefaultSeat;

          let defaultColorSeat = seat.hidden
            ? colorHidden || this.colorDefaultHidden
            : colorLevel;
          if (seat.eventSeat) {

            if (seat.cart) {
              defaultColorSeat = this.colorDefaultSelect;
            }
            changeSeatColor(
              seat,
              colorSelect ? this.colorDefaultSelect : defaultColorSeat
            );
          }
        });
      }
    });
    this.canvas.renderAll();
  }
  // Botones externos de zoom
  zoomMap(plus: boolean, event?: any, delta: any = 50) {
    let zoom = this.getZoom(plus, delta * 4);
    // Se amplía/aleja sobre el centro de lo que se está viendo. Con setZoom, fabric escala desde
    // la esquina del lienzo y el plano se escapaba de la pantalla en cuanto había paneo.
    const view = this.getVisibleCanvasRect();
    if (view) {
      this.canvas.zoomToPoint(new fabric.Point(view.left + view.width / 2, view.top + view.height / 2), zoom);
    } else {
      this.canvas.setZoom(zoom);
    }
    this.canvas.renderAll();
    // Los botones de la plantilla llaman sin evento.
    event?.stopPropagation();
  }

  // Ajusta el zoom y centra el plano para que quepa entero en la zona visible al abrir el mapa.
  // Sin esto, los mapas grandes (el Palacio de los Deportes ocupa ~8300x4450 px de lienzo) se
  // abrían al 50% y solo se veía una esquina, obligando a arrastrar a ciegas.
  fitMapToViewport(): void {
    if (!this.canvas) return;
    const objects = (this.canvas.getObjects() || []).filter((obj: any) =>
      obj.visible !== false && obj !== this.lassoOverlay && obj !== this.rectOverlay);
    if (!objects.length) return;

    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    objects.forEach((obj: any) => {
      // absolute = true → el rectángulo no depende del zoom/paneo actual.
      const bound = obj.getBoundingRect(true, true);
      minX = Math.min(minX, bound.left);
      minY = Math.min(minY, bound.top);
      maxX = Math.max(maxX, bound.left + bound.width);
      maxY = Math.max(maxY, bound.top + bound.height);
    });
    const contentWidth = maxX - minX;
    const contentHeight = maxY - minY;
    if (!(contentWidth > 0) || !(contentHeight > 0)) return;

    const view = this.getVisibleCanvasRect();
    if (!view) return;

    const margin = 24;
    const zoomX = (view.width - margin * 2) / contentWidth;
    const zoomY = (view.height - margin * 2) / contentHeight;
    // Techo 0.6: el zoom de siempre, para que un mapa pequeño no se abra ampliado de más.
    let zoom = Math.min(zoomX, zoomY, 0.6);
    zoom = Math.max(zoom, this.MIN_ZOOM);

    const offsetX = view.left + view.width / 2 - (minX + contentWidth / 2) * zoom;
    const offsetY = view.top + view.height / 2 - (minY + contentHeight / 2) * zoom;
    this.canvas.setViewportTransform([zoom, 0, 0, zoom, offsetX, offsetY]);
    this.canvas.renderAll();
  }

  // Parte del lienzo que se ve de verdad, en px del propio canvas: el canvas es un lienzo fijo de
  // 3000x3000 que `.content-map-select` recorta (no hay scroll, se navega arrastrando), así que la
  // zona útil es la intersección de ambos.
  private getVisibleCanvasRect(): { left: number, top: number, width: number, height: number } | null {
    const el = this.canvas?.getElement?.();
    if (!el) return null;
    const canvasRect = el.getBoundingClientRect();
    const width = this.canvas.getWidth();
    const height = this.canvas.getHeight();
    let left = 0, top = 0, right = width, bottom = height;
    const clipper = el.closest('.content-map-select') as HTMLElement | null;
    if (clipper) {
      const clipRect = clipper.getBoundingClientRect();
      left = Math.max(0, clipRect.left - canvasRect.left);
      top = Math.max(0, clipRect.top - canvasRect.top);
      right = Math.min(width, clipRect.right - canvasRect.left);
      bottom = Math.min(height, clipRect.bottom - canvasRect.top);
    }
    const visibleWidth = right - left;
    const visibleHeight = bottom - top;
    // Si el canvas todavía está oculto (o el contenedor sin medir) no se puede ajustar nada.
    if (visibleWidth < 50 || visibleHeight < 50) return null;
    return { left, top, width: visibleWidth, height: visibleHeight };
  }

  getZoom(plus: boolean, delta: any = 50) {
    var zoom = this.canvas.getZoom();
    var plusDelta = plus ? -delta : delta;
    zoom *= 0.999 ** plusDelta;
    if (zoom > 10) zoom = 10;
    // Suelo de zoom bajo (era 0.2): en los mapas grandes, como el Palacio de los Deportes, con 0.2
    // el plano seguía sin caber en pantalla y no había forma de alejarse más.
    if (zoom < this.MIN_ZOOM) zoom = this.MIN_ZOOM;
    return zoom;
  }

  formatDateFront(date: string) {
    return new Date(date);
  }

  formatNumber(floatValue = 1, decimals = 2, multiplier = 1) {
    let floatMultiplied = floatValue * multiplier;
    let stringFloat = floatMultiplied + "";
    let arraySplitFloat = stringFloat.split(".");
    let decimalsValue = "0";
    if (arraySplitFloat.length > 1) {
      decimalsValue = arraySplitFloat[1].slice(0, decimals);
    }
    let integerValue = arraySplitFloat[0];
    let arrayFullStringValue = [integerValue, decimalsValue];
    let FullStringValue = arrayFullStringValue.join(".")
    let floatFullValue = parseFloat(FullStringValue) + "";
    let formatFloatFullValue = new Intl.NumberFormat('es-ES', { minimumFractionDigits: decimals, style: 'currency', currency: 'EUR' }).format(Number(floatFullValue));
    return formatFloatFullValue;
  }

  // ✅ Método para convertir array a objeto de clave-valor
  convertArrayToKeyValueObject(configurationArray: any[]): { [key: string]: any } {
    const result: { [key: string]: any } = {};

    if (Array.isArray(configurationArray)) {
      configurationArray.forEach(item => {
        // Cada item es un objeto con una clave que contiene los datos
        const keys = Object.keys(item);
        if (keys.length > 0) {
          const key = keys[0]; // obj_1, obj_2, etc.
          result[key] = item[key]; // Asignar el valor completo
        }
      });
    }

    return result;
  }

  // ✅ Método para agrupar secciones y asientos (si es necesario)
  groupSectionsAndSeats(sections: any[], seats: any[]): any[] {
    const seatSections: any[] = [];

    // Build a seat lookup grouped by section id — O(total_seats) instead of O(sections × seats)
    const seatsBySection = new Map<number, any[]>();
    for (const seat of seats) {
      const arr = seatsBySection.get(seat.section) || [];
      arr.push(seat);
      seatsBySection.set(seat.section, arr);
    }

    sections.forEach(section => {
      const sectionSeats = seatsBySection.get(section.id_section) || [];
      const sectionObject = {
        id: section.id_section,
        name: section.name,
        seats: sectionSeats.length,
        color: section.color,
        columns: section.configuration?.seatsGroupConfig.columns,
        rows: section.configuration?.seatsGroupConfig.rows,
        configuration: section.configuration,
        id_level: section.id_level,
        id_bbdd: section.id
      };

      seatSections.push({
        section: sectionObject,
        elements: sectionSeats
      });
    });

    return seatSections;
  }

  recreateSectionsFromStorage() {
    if (Object.keys(this.seatSections).length === 0) {
      return;
    }

    // ✅ Recrear otros objetos del canvas
    if (Object.keys(this.canvasObjects).length > 0) {
      Object.values(this.canvasObjects).forEach((objectData: any) => {
        this.createObjectFromData(objectData);
      });
    }

    Object.values(this.seatSections).forEach((sectionData: any) => {
      this.createSectionFromData(sectionData);
    });

    this.canvas.renderAll();
    if (this.passMode && this.passPreselectedSeatIds?.length > 0) {
      this.applyPassPreselectedColors();
    }
  }

  // Método para crear una sección desde los datos guardados
  createSectionFromData(sectionData: any) {
    const { section, elements } = sectionData;
    // Las capas ocultadas en el editor del mapa (icono de ojo) guardan configuration.hidden = true
    // y no deben renderizarse en taquilla, igual que no se renderizan en la web.
    if (section?.configuration?.hidden) {
      return;
    }
    const { mainGroup, sectionObject } = this.generateMapService.addGroupSeats(section.rows, section.columns, this.sectionNumber, sectionData, true, this.buysBuySelect, this.blockedSeats, this.cartBookings, undefined, this.reservedSeats);

    this.canvas.add(mainGroup);
  }

  createCircleInfo(sectionData: any) {
    const mainGroup = this.generateMapService.addGroupNumbers(sectionData.rows, sectionData.columns, sectionData, true);
    this.canvas.add(mainGroup);
  }

  // ✅ Método para crear objetos desde datos guardados
  createObjectFromData(objectData: any) {
    const { type, configuration, id } = objectData;
    // Las capas ocultadas en el editor del mapa (icono de ojo) guardan configuration.hidden = true
    // y no deben renderizarse en taquilla, igual que no se renderizan en la web.
    if (configuration?.hidden) {
      return;
    }
    const configWithId = { ...configuration, objectId: configuration?.objectId || id };

    switch (type) {
      case 'scenary':
        this.recreateScenary(configWithId);
        break;
      case 'polygon':
        this.recreatePolygon(configWithId);
        break;
      case 'rect':
        this.recreateRect(configWithId);
        break;
      case 'ellipse':
        this.recreateEllipse(configWithId);
        break;
      case 'line':
        this.recreateLine(configWithId);
        break;
      case 'standSection':
        this.recreateStandSection(configWithId);
        break;
      case 'text':
        this.recreateText(configWithId);
        break;
      case 'groupCircles':
        this.createCircleInfo(configWithId);
        break;
      case 'image':
      case 'svg':
        this.recreateImage(configWithId);
        break;
      default:
        console.warn('Tipo de objeto no reconocido:', type);
    }
  }

  // ✅ Métodos para recrear cada tipo de objeto
  async recreateScenary(config: any) {
    await this.generateMapService.createScenary(
      this.canvas,
      config.fill || this.colorDefaultStage,
      this.screenElement,
      config, // Pasar toda la configuración guardada
      true
    );
  }

  recreatePolygon(config: any) {
    const polygon = this.generateMapService.addPoligonObject(config);
    polygon.set({ selectable: false, evented: false, hoverCursor: 'default' });
    this.canvas.add(polygon);
    this.canvas.sendToBack(polygon);
    this.canvas.renderAll();
  }

  recreateRect(config: any) {
    const rect = this.generateMapService.addRectObject(config);
    rect.set({ selectable: false, evented: false, hoverCursor: 'default' });
    this.canvas.add(rect);
    this.canvas.sendToBack(rect);
    this.canvas.renderAll();
  }

  recreateEllipse(config: any) {
    const ellipse = this.generateMapService.addEllipseObject(config);
    ellipse.set({ selectable: false, evented: false, hoverCursor: 'default' });
    this.canvas.add(ellipse);
    this.canvas.sendToBack(ellipse);
    this.canvas.renderAll();
  }

  recreateLine(config: any) {
    const line = this.generateMapService.addLineObject(config);
    line.set({ selectable: false, evented: false, hoverCursor: 'default' });
    this.canvas.add(line);
    this.canvas.sendToBack(line);
    this.canvas.renderAll();
  }

  recreateStandSection(config: any) {
    this.recreateGroupInfo(this.shoesElement, config.text || 'Pista', config.color || this.colorDefaultStand, 'Capacidad', config);
  }

  // Imágenes y SVG del mapa: un SVG se pinta como vector (nítido a cualquier zoom) y una imagen
  // desde su src. Van justo por debajo de las butacas para que nunca tapen el mapa ni intercepten
  // los clics de venta.
  async recreateImage(config: any) {
    if (!config?.src && !config?.svg) {
      return;
    }
    const img = config.svg
      ? await this.generateMapService.addSvgObject(config.svg, config)
      : await this.generateMapService.addImageObject(config.src, config);
    if (!img) {
      return;
    }
    img.set({ selectable: false, evented: false, hoverCursor: 'default' });
    this.canvas.add(img);
    const firstSeatIndex = this.canvas.getObjects().findIndex((obj: any) => obj.groupSeat);
    if (firstSeatIndex >= 0) {
      this.canvas.moveTo(img, firstSeatIndex);
    }
    this.canvas.renderAll();
  }

  recreateGroupInfo(icon: string, text: string, color: any, subtitle: string, config: any) {
    const rectangle = this.generateMapService.createRect(color, 300, 150);
    const textComponent = this.generateMapService.createTextComponent(text, 18, -30);
    let elements = [rectangle, textComponent];

    if (subtitle) {
      const textCapacity = this.generateMapService.createTextComponent(subtitle, 16, 40);
      elements.push(textCapacity);
    }

    var canvas = this.canvas;
    fabric.loadSVGFromURL(icon, function (objects, options) {
      var obj = fabric.util.groupSVGElements(objects, options);
      obj.set({ top: -5, scaleX: 0.05, scaleY: 0.05, originX: 'center', hasControls: false });
      elements.push(obj);

      var group = new fabric.Group(elements, {
        left: config.left,
        top: config.top,
        width: 300,
        height: 150,
        scaleX: config.scaleX || 1,
        scaleY: config.scaleY || 1,
        angle: config.angle || 0,
        capacity: config.capacity || 50,
        lockRotation: true,
        eventSeat: true,
        isSection: true,
        section: config.section,
        objectId: config.objectId
      });

      group.subTargetCheck = true;
      group.perPixelTargetFind = true;
      group.lockMovementY = true;
      group.lockMovementX = true;
      group.lockRotation = true;
      group.lockScalingFlip = true;
      group.lockScalingY = true;
      group.lockScalingX = true;
      group.hoverCursor = 'pointer';
      group.hasBorders = false;
      group.hasControls = false;
      group.setControlVisible('mtr', false);
      canvas.add(group);
      canvas.renderAll();
    });
  }

  recreateText(config: any) {
    // Bake scale into width/height so Fabric wraps at the full visual width, not the unscaled one.
    // This prevents text from splitting into extra lines when scaleX > 1.
    const scaleX = config.scaleX || 1;
    const scaleY = config.scaleY || 1;
    const text = new fabric.Textbox(config.text || 'Escribe un texto...', {
      width: (config.width || 200) * scaleX,
      height: (config.height || 100) * scaleY,
      fontSize: (config.fontSize || 24) * scaleY,
      lineHeight: config.lineHeight || 1,
      fontFamily: config.fontFamily || 'Satoshi-Regular',
      fill: config.fill || '#000000',
      cursorColor: config.cursorColor || '#FF4D80',
      left: config.left,
      top: config.top,
      scaleX: 1,
      scaleY: 1,
      angle: config.angle || 0,
      eventSeat: false,
      objectId: config.objectId
    });

    text.subTargetCheck = true;
    text.perPixelTargetFind = true;
    text.lockMovementY = true;
    text.lockMovementX = true;
    text.lockRotation = true;
    text.lockScalingFlip = true;
    text.lockScalingY = true;
    text.lockScalingX = true;
    text.hoverCursor = 'pointer';
    text.hasBorders = false;
    text.hasControls = false;
    this.canvas.add(text);
  }

  // ─── Mass lasso selection ────────────────────────────────────────────────────

  toggleButtonPanMode() {
    this.buttonPanMode = !this.buttonPanMode;
    this.pausePanning = true;
    if (this.canvas) this.canvas.defaultCursor = this.buttonPanMode ? 'move' : 'crosshair';
  }

  toggleMassSelection(forceExit?: 'force-exit') {
    // Quitar el foco del botón para que la barra espaciadora no lo reaccione
    (document.activeElement as HTMLElement)?.blur();
    // Permitir salir aunque loadingMassCart esté activo si es forzado
    if (this.loadingMassCart && !this.massSelectionMode && !forceExit) return;
    if (forceExit && this.massSelectionMode) {
      this.massSelectionMode = false;
    } else {
      this.massSelectionMode = !this.massSelectionMode;
    }
    if (!this.massSelectionMode) {
      this.clearMassSelection();
      if (this.lassoOverlay) {
        this.canvas.remove(this.lassoOverlay);
        this.lassoOverlay = null;
      }
      if (this.rectOverlay) {
        this.canvas.remove(this.rectOverlay);
        this.rectOverlay = null;
      }
      this.isDrawingLasso = false;
      this.lassoPoints = [];
      this.rectStart = null;
      this.buttonPanMode = false;
      this.pausePanning = true;
      if (this.canvas) {
        this.canvas.defaultCursor = 'default';
        this.canvas.set('backgroundColor', '#f8f8f8');
        this.canvas.renderAll();
      }
      this.rectSelectionMode = false;
    } else {
      // Activar por defecto el modo rectángulo al activar la selección masiva
      this.activateRectMode();
      if (this.canvas) {
        this.canvas.defaultCursor = 'crosshair';
        this.canvas.set('backgroundColor', '#fff0f4'); // Rosa claro
        this.canvas.renderAll();
      }
    }
    if (this.activedSeat) this.closeActived();
  }

  startLasso(e: any) {
    this.isDrawingLasso = true;
    const pointer = this.canvas.getPointer(e.e);
    this.lassoPoints = [{ x: pointer.x, y: pointer.y }];
    if (this.lassoOverlay) {
      this.canvas.remove(this.lassoOverlay);
    }
    const zoom = this.canvas.getZoom();
    this.lassoOverlay = new fabric.Polyline(this.lassoPoints as any, {
      fill: 'rgba(255, 77, 128, 0.12)',
      stroke: '#FF4D80',
      strokeWidth: 2 / zoom,
      strokeDashArray: [6 / zoom, 3 / zoom],
      selectable: false,
      evented: false,
      objectCaching: false,
    } as any);
    // Evitar que Fabric.js descarte el overlay por culling cuando el bounding box
    // queda desactualizado durante el autoscroll rápido
    (this.lassoOverlay as any).isOnScreen = () => true;
    this.canvas.add(this.lassoOverlay);
    this.canvas.renderAll();
  }

  updateLasso(e: any) {
    if (!this.isDrawingLasso || !this.lassoOverlay) return;
    const pointer = this.canvas.getPointer(e.e);
    this.lassoPoints.push({ x: pointer.x, y: pointer.y });
    (this.lassoOverlay as any).set({ points: [...this.lassoPoints] });
    this.lassoOverlay.setCoords();
    this.canvas.requestRenderAll();
    // Guardar la última posición conocida del mouse para auto-scroll
    this.lastLassoPointer = { x: pointer.x, y: pointer.y };
  }

  finishLasso() {
    this.isDrawingLasso = false;
    this.lastLassoPointer = null;
    if (this.lassoOverlay) {
      this.canvas.remove(this.lassoOverlay);
      this.lassoOverlay = null;
    }
    if (this.lassoPoints.length >= 3) {
      this.applyLassoSelection(this.lassoPoints);
    }
    this.lassoPoints = [];
    this.canvas.renderAll();
  }

  applyLassoSelection(points: { x: number; y: number }[]) {
    const seatsInLasso: any[] = [];
    this.canvas._objects.forEach((element: any) => {
      if (!element.groupSeat) return;
      const seatsGroup = element._objects?.[1];
      if (!seatsGroup?._objects) return;
      seatsGroup._objects.forEach((seat: any) => {
        if (!seat.eventSeat || !seat.selectable || seat.hidden) return;
        // Use the seat's own world matrix (chains through all parent groups)
        // Transforming (0,0) gives the seat's absolute canvas center
        const seatMatrix = seat.calcTransformMatrix();
        const absCenter = fabric.util.transformPoint(new fabric.Point(0, 0), seatMatrix);
        if (this.isPointInPolygon({ x: absCenter.x, y: absCenter.y }, points)) {
          seatsInLasso.push(seat);
        }
      });
    });

    if (this.selectionModeType === 'new') {
      this.massSelectedSeats.forEach(s => this.deselectMassSeat(s));
      this.massSelectedSeats = [...seatsInLasso];
    } else if (this.selectionModeType === 'add') {
      seatsInLasso.forEach(seat => {
        if (!this.massSelectedSeats.find(s => s.id === seat.id)) {
          this.massSelectedSeats.push(seat);
        }
      });
    } else if (this.selectionModeType === 'subtract') {
      seatsInLasso.forEach(seat => {
        const idx = this.massSelectedSeats.findIndex(s => s.id === seat.id);
        if (idx !== -1) {
          this.deselectMassSeat(seat);
          this.massSelectedSeats.splice(idx, 1);
        }
      });
    }
    // In pass mode, enforce the seat limit
    if (this.passMode && this.massSelectedSeats.length > this.passMaxSeats) {
      const excess = this.massSelectedSeats.splice(this.passMaxSeats);
      excess.forEach(s => this.deselectMassSeat(s));
    }
    // Re-paint all currently selected seats
    this.massSelectedSeats.forEach(s => this.selectMassSeat(s));
    if (this.massSelectedSeats.length > 0) {
      this.getMassEnabledTickets();
    }
  }

  selectMassSeat(seat: any) {
    const el = seat._objects?.find((v: any) => v.type !== 'text');
    el?.set('fill', this.colorDefaultSelect);
    seat._objects?.filter((v: any) => v.type === 'text' || v.type === 'path')
      .forEach((t: any) => t.set('fill', 'white'));
  }

  deselectMassSeat(seat: any) {
    this.changeColorBasic(seat);
  }

  clearMassSelection() {
    this.massSelectedSeats.forEach(s => this.deselectMassSeat(s));
    this.massSelectedSeats = [];
    this.massTicketOption = null;
    this.massOptionSection = [];
    if (this.canvas) this.canvas.renderAll();
  }

  isPointInPolygon(point: { x: number; y: number }, polygon: { x: number; y: number }[]): boolean {
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].x, yi = polygon[i].y;
      const xj = polygon[j].x, yj = polygon[j].y;
      if (((yi > point.y) !== (yj > point.y)) &&
        (point.x < ((xj - xi) * (point.y - yi)) / (yj - yi) + xi)) {
        inside = !inside;
      }
    }
    return inside;
  }

  addMassSeatsToCart() {
    if (!this.massTicketOption || this.massSelectedSeats.length === 0 || this.loadingMassCart) return;

    // Pass mode: emit each seat as a pass selection instead of adding to real cart
    if (this.passMode) {
      if (this.passSelectedCount >= this.passMaxSeats) {
        this.dialog.open(DialogGenericComponent, {
          data: {
            title: 'Entrada ya seleccionada',
            subtitle: 'Ya tienes una entrada seleccionada para este evento. Elimínala primero del abono para poder seleccionar una nueva.',
            icon: 'info',
            buttons: [{ label: 'Cerrar', action: () => this.dialog.closeAll() }],
          },
        });
        return;
      }
      // Precio fijo: cada opción es el precio de un nivel, así que solo se llevan las butacas de ese nivel
      const passSeats = this.isFixedPricePassMode() && this.massTicketOption._levelId
        ? this.massSelectedSeats.filter(seat => {
            const sec = this.sectionsEnabled.find((s: any) => s.id_section == seat.section?.id);
            return sec?.id_level == this.massTicketOption._levelId;
          })
        : this.massSelectedSeats;
      // Only take up to the remaining allowed slots
      const remaining = this.passMaxSeats - this.passSelectedCount;
      const seatsToEmit = passSeats.slice(0, remaining);
      seatsToEmit.forEach(seat => {
        const linepayload: any = {
          id_event: this.event.id,
          id_session: this.sessionSelected.id,
          quantity: 1,
          id_ticket: this.massTicketOption.id,
          id_seat: seat.id,
        };
        this.passSelection.emit({
          ...linepayload,
          _display: {
            eventTitle: this.event?.title,
            eventImage: this.event?.image_url,
            ticketName: this.massTicketOption?.name || this.massTicketOption?.ticket_name,
            ticketPrice: this.massTicketOption?.price != null ? +this.massTicketOption.price : null,
            sessionDate: this.sessionSelected?.start_date,
            seatLabel: seat ? `${seat.section?.name || ''} ${seat.row ? 'Fila ' + seat.row : ''} ${seat.seat ? 'Asiento ' + seat.seat : ''}`.trim() : null,
            seatSection: seat?.section?.name || null,
            seatRow: seat?.row || null,
            seatSeat: seat?.seat || null
          }
        });
      });
      this.changeSeatsAddToCart();
      this.massSelectedSeats = [];
      this.massTicketOption = null;
      this.massOptionSection = [];
      this.canvas.renderAll();
      return;
    }

    this.loadingMassCart = true;

    // If the chosen option is scoped to a specific level, only add seats from that level
    const seatsToAdd = this.massTicketOption._levelId
      ? this.massSelectedSeats.filter(seat => {
          const sec = this.sectionsEnabled.find((s: any) => s.id_section == seat.section?.id);
          return sec?.id_level == this.massTicketOption._levelId;
        })
      : [...this.massSelectedSeats];

    // Pass mode: emit each seat as a pass selection instead of adding to real cart
    if (this.passMode) {
      if (this.passSelectedCount >= this.passMaxSeats) {
        this.dialog.open(DialogGenericComponent, {
          data: {
            title: 'Entrada ya seleccionada',
            subtitle: 'Ya tienes una entrada seleccionada para este evento. Elimínala primero del abono para poder seleccionar una nueva.',
            icon: 'info',
            buttons: [{ label: 'Cerrar', action: () => this.dialog.closeAll() }],
          },
        });
        return;
      }
      // Only take up to the remaining allowed slots
      const remaining = this.passMaxSeats - this.passSelectedCount;
      const seatsToEmit = this.massSelectedSeats.slice(0, remaining);
      seatsToEmit.forEach(seat => {
        const linepayload: any = {
          id_event: this.event.id,
          id_session: this.sessionSelected.id,
          quantity: 1,
          id_ticket: this.massTicketOption.id,
          id_seat: seat.id,
        };
        this.passSelection.emit({
          ...linepayload,
          _display: {
            eventTitle: this.event?.title,
            eventImage: this.event?.image_url,
            ticketName: this.massTicketOption?.name || this.massTicketOption?.ticket_name,
            ticketPrice: this.massTicketOption?.price != null ? +this.massTicketOption.price : null,
            sessionDate: this.sessionSelected?.start_date,
            seatLabel: seat ? `${seat.section?.name || ''} ${seat.row ? 'Fila ' + seat.row : ''} ${seat.seat ? 'Asiento ' + seat.seat : ''}`.trim() : null,
            seatSection: seat?.section?.name || null,
            seatRow: seat?.row || null,
            seatSeat: seat?.seat || null
          }
        });
      });
      this.changeSeatsAddToCart();
      this.massSelectedSeats = [];
      this.massTicketOption = null;
      this.canvas.renderAll();
      return;
    }

    this.loadingMassCart = true;

    const ticketId = this.massTicketOption.id;

    const markSeatsAdded = (seats: any[]) => {
      seats.forEach(seat => {
        seat.selected = true;
        seat.selectable = false;
        seat.actived = false;
        const el = seat._objects?.find((v: any) => v.type !== 'text');
        if (el) el.set('fill', this.colorDefaultSelect);
      });
      this.loadingMassCart = false;
      // Remove only the seats that were added; keep any remaining selected seats
      const addedIds = new Set(seats.map((s: any) => s.id));
      this.massSelectedSeats = this.massSelectedSeats.filter((s: any) => !addedIds.has(s.id));
      this.massTicketOption = null;
      if (this.massSelectedSeats.length > 0) {
        this.getMassEnabledTickets();
      } else {
        this.massOptionSection = [];
      }
      this.canvas.renderAll();
    };

    // Modo reserva: igual que addToReservation individual, sin validación previa
    if (this.reservationId) {
      const lines = seatsToAdd.map(seat => ({
        id_event: this.event.id,
        id_session: this.sessionSelected.id,
        id_ticket: ticketId,
        id_seat: seat.id,
        quantity: 1,
      }));

      this.reservasService.addManyLines(this.reservationId, lines).subscribe({
        next: () => {
          this.reservasService.triggerLinesRefresh();
          markSeatsAdded(seatsToAdd);
        },
        error: () => {
          this.loadingMassCart = false;
          this.dialog.open(DialogGenericComponent, {
            data: {
              title: 'Error al añadir a la reserva',
              subtitle: 'No se han podido añadir los asientos a la reserva. Por favor, inténtalo de nuevo más tarde.',
              icon: 'error',
              buttons: [{ label: 'Cerrar', action: () => this.dialog.closeAll() }],
            },
          });
        },
      });
      return;
    }

    // Modo carrito: validar asientos antes de añadir
    const seatIds = seatsToAdd.map(s => s.id);
    this.ticketsEventService.validateSeatsInBatch(this.sessionSelected.id, seatIds, ticketId).subscribe({
      next: (res: any) => {
        const validSeats: any[] = seatsToAdd.filter(s => res.data.valid_seats.includes(s.id));
        const invalidSeats: any[] = seatsToAdd.filter(s => res.data.invalid_seats.includes(s.id));

        if (invalidSeats.length > 0) {
          console.warn('Asientos no válidos para este tipo de entrada:', invalidSeats);
          invalidSeats.forEach(seat => this.deselectMassSeat(seat));
        }

        if (validSeats.length === 0) {
          this.loadingMassCart = false;
          this.dialog.open(DialogGenericComponent, {
            data: {
              title: 'No se pudieron añadir',
              subtitle: `Ninguno de los ${invalidSeats.length} asiento(s) seleccionado(s) dispone del tipo de entrada elegido.`,
              icon: 'info',
              buttons: [{ label: 'Cerrar', action: () => this.dialog.closeAll() }],
            },
          });
          return;
        }

        const cartLines = validSeats.map(seat => ({
          id_event: this.event.id,
          id_session: this.sessionSelected.id,
          id_ticket: ticketId,
          id_seat: seat.id,
          quantity: 1,
        }));

        this.cartService.addManyToCart(cartLines).subscribe({
          next: () => {
            this.cartService.getCart().subscribe();
            markSeatsAdded(validSeats);

            if (invalidSeats.length > 0) {
              this.dialog.open(DialogGenericComponent, {
                data: {
                  title: 'Algunos asientos no añadidos',
                  subtitle: `Se añadieron ${validSeats.length} asiento(s) al carrito. ${invalidSeats.length} asiento(s) no se pudieron añadir porque no disponen del tipo de entrada elegido.`,
                  icon: 'info',
                  buttons: [{ label: 'Cerrar', action: () => this.dialog.closeAll() }],
                },
              });
            }
          },
          error: () => {
            this.loadingMassCart = false;
            this.dialog.open(DialogGenericComponent, {
              data: {
                title: 'Error al añadir al carrito',
                subtitle: 'No se han podido añadir los asientos al carrito. Por favor, inténtalo de nuevo más tarde.',
                icon: 'error',
                buttons: [{ label: 'Cerrar', action: () => this.dialog.closeAll() }],
              },
            });
          },
        });
      },
      error: () => {
        this.loadingMassCart = false;
        this.dialog.open(DialogGenericComponent, {
          data: {
            title: 'Error al validar asientos',
            subtitle: 'No se han podido validar los asientos seleccionados. Por favor, inténtalo de nuevo más tarde.',
            icon: 'error',
            buttons: [{ label: 'Cerrar', action: () => this.dialog.closeAll() }],
          },
        });
      }
    });
  }
}

function changeSeatColor(elementSeat, color) {
  let elementStroke = elementSeat._objects.find(
    (value) => value.type != 'text'
  );
  elementStroke.set('fill', color);
  let rgb = hexToRgb(color);
  let textColor =
    rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114 > 186 ? '#000' : '#fff';
  let elementsText = elementSeat._objects.filter(
    (value) => value.type == 'text' || value.type == 'path'
  );
  elementsText.forEach((elementText) => {
    elementText.set('fill', textColor);
  });
  return elementSeat;
}
function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
    }
    : null;
}
function keepPositionInBounds(canvas: any, e: any) {
  canvas.relativePan(new fabric.Point(e.e.movementX, e.e.movementY));
  return canvas;
}
function formatTimeFromISO(isoDateString: string): string {
  // Create a Date object from the ISO string
  const date = new Date(isoDateString);

  // Get hours and minutes
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');

  // Format the time as HH:mm
  return `${hours}:${minutes}`;
}
